export default {
  quickActions: 'Tác vụ nhanh',
  servers: {
    name: 'Máy chủ',
    auto: 'Tự động',
    vietnam: 'Việt Nam',
    singapore: 'Singapore',
    main: 'Chính',
    reserve: 'Dự phòng'
  },
  boss: 'Chủ shop',
  cart: 'Giỏ hàng',
  line: 'Dòng',
  gotit: 'Đã hiểu',
  timezone: 'Múi giờ',
  timezoneHint: 'Cập nhật múi giờ có thể sẽ làm thay đổi số liệu báo cáo',
  collapse: 'Thu gọn',
  expand: 'Mở rộng',
  salesman: 'Người bán',
  download: 'Tải xuống',
  sort: 'Sắp xếp',
  appNotAvailable: 'Ứng dụng này chưa sẵn có. Vui lòng thử lại sau!',
  getStart: 'Bắt đầu',
  itemPerPage: 'Số lượng mỗi trang',
  takeAway: 'Mang về',
  printBill: 'In hoá đơn (Bill)',
  barcodeText: 'Mã code (chữ)',
  now: 'Bây giờ',
  hour: 'giờ',
  minutes: 'phút',
  second: 'giây',
  limitFeatureForFree: 'Tính năng này chỉ dành cho phiên bản cao cấp. Vui lòng nâng cấp để sử dụng tính năng này!',
  orderIsPaying: 'Đơn hàng đang thanh toán',
  canUpdateOrder: 'Bạn có chắc chắn hủy? Những thay đổi sẽ không được cập nhật!',
  charge: 'Tính tiền',
  checkout: 'Tính tiền',
  commingSoon: 'Chưa có sẵn',
  upcoming: 'Sắp diễn ra',
  showing: 'Đang hiển thị',
  addShortCut: 'Lối tắt thêm',
  billUIChoice: 'Chọn giao diện hoá đơn',
  qrUIChoice: 'Chọn giao diện mã QR',
  devicePermissionDenied: 'Bạn cần cấp quyền để ứng dụng thực hiện chức năng này!',
  permissionNotifyInfo: 'Bạn cần cấp quyền thông báo để chức năng này hoạt động!',
  oldVersion: 'Phiên bản cũ hơn',
  changeText: 'Thay đổi',
  confirmDelete: 'Bạn có chắc chắn muốn xoá mục này?',
  value: 'Giá trị',
  deprecated: 'Sắp bỏ',
  saving: 'Tiết kiệm',
  active: 'Kích hoạt',
  notActive: 'Chưa kích hoạt',
  hidden: 'Đã ẩn',
  content: 'Nội dung',
  close: 'Đóng',
  featureUnderDev: 'Chức năng này đang được team mình hoàn thiện. Bạn vui lòng quay lại sau nha!!',
  spending: 'Chi tiêu',
  overview: 'Tổng quan',
  recommend: 'Khuyên dùng',
  savePdf: 'Lưu file pdf',
  bankQR: 'Mã QR STK',
  quantityInvalid: 'Số lượng không hợp lệ',
  returnToHome: 'Trở về màn hình chính',
  forever: 'Mãi mãi',
  expired: 'Hết hạn',
  expiredShort: 'HSD',
  barcodeTable: 'Bảng mã vạch sản phẩm',
  price: 'Giá',
  autoGen: 'Tự động tạo',
  check: 'Kiểm tra',
  signature: 'Chữ ký',
  permission: 'Phân quyền',
  staffLogin: 'Đăng nhập nhân viên',
  staffSale: 'Nhân viên bán hàng',
  updateInfo: 'Cập nhật thông tin',
  staffPermission: {
    title: 'Phân quyền cho nhân viên',
    detail: 'Phân quyền cho nhân viên sử dụng trực tiếp trên WEB/APP quản lý. App dành riêng cho nhân viên sẽ có thể không có một số chức năng này',
    allOrderType: 'Đơn bán hàng, nhập hàng, trả hàng',
    showRevenue: 'Hiển thị lợi nhuận trong đơn hàng',
    editPriceDetail: 'Cho phép nhân viên sửa giá bán trong khi bán hàng. Nếu không sản phẩm sẽ bán giá lẻ.',
    financial: 'Phiếu thu chi',
    showAllCustomer: 'Hiển thị tất cả khách hàng',
    showAllCustomerDetail: 'Được truy cập vào tất cả các khách hàng dù không phải của nhân viên này tạo ',
    editPrice: 'Cho phép sửa giá bán',
    showAllOrder: 'Hiển thị tất cả đơn hàng',
    showAllOrderDetail: 'Hiển thị tất cả đơn hàng của quản lý và nhân viên khác',
    canViewFinancialStats: 'Xem dòng tiền',
    canViewFinancialStatsDetail: 'Cho phép nhân viên xem báo cáo dòng tiền của mình',
    canViewDebtStats: 'Xem công nợ',
    canViewDebtStatsDetail: 'Xem công nợ của toàn bộ cửa hàng',
    canViewWarehouseStats: 'Xem báo cáo kho hàng',
    canViewWarehouseStatsDetail: 'Xem báo cáo tình trạng kho hàng',
    canViewSalesStats: 'Xem báo cáo doanh thu',
    canViewSalesStatsDetail: 'Xem báo cáo doanh thu của toàn bộ cửa hàng',
    canExportEInvoice: 'Xuất hoá đơn điện tử',
    canExportEInvoiceDetail: 'Nhân viên có thể xuất hoá đơn điện tử',
    roleAndAccess: 'Vai trò & Quyền truy cập',
    roleAndAccessSubtitle: 'Cấu hình vai trò và quyền truy cập kho cho nhân viên',
    role: 'Vai trò',
    roleManager: 'Quản lý',
    roleRegular: 'Nhân viên thường',
    warehouseAccess: 'Quyền truy cập kho',
    allWarehouses: 'Tất cả kho',
    selectWarehouses: 'Chọn kho được truy cập:',
    warehouseAccessDenied: 'Bạn không có quyền truy cập kho này',
    managerNote: 'Quản lý có tất cả các quyền trừ cập nhật tài khoản shop và quản lý nhân viên.',
    dataOperation: 'Quyền thao tác dữ liệu',
    featuresAndStats: 'Quyền xem & tính năng'
  },
  renew: 'Mua Ngay',
  updatedAt: 'Cập nhật lúc',
  saveDraft: 'Lưu Nháp',
  buy: 'Mua',
  birthday: 'Sinh nhật',
  barcodeNotFound: 'Không tìm thấy mã barcode này!',
  saved: 'Đã lưu',
  reality: 'Thực tế',
  difference: 'Chênh lệch',
  hide: 'Ẩn',
  editComponent: 'Sửa thành phần',
  amount: 'Số lượng',
  search: 'Tìm kiếm',
  simple: 'Đơn giản',
  more: 'Thêm',
  share: 'Chia sẻ',
  inventoryDelivery: 'Phiếu xuất kho',
  type: 'Loại',
  transactionHistory: 'Lịch sử giao dịch',
  limitWarning: 'Tài khoản của bạn bị hạn chế do thanh toán bị hoàn nhiều lần. Nếu vượt quá 3 lần, tài khoản sẽ bị khóa vĩnh viễn không thể khôi phục dữ liệu. Xin cảm ơn!',
  upgradePro: 'Nâng cấp',
  iapSupport: 'Thanh toán chuyển khoản sẽ được giảm giá 5% áp dụng gói từ 6 tháng. Vui lòng liên hệ qua Facebook Messenger để được tư vấn',
  emptyData: 'Chưa có dữ liệu',
  seemore: 'Xem thêm',
  version: 'Phiên bản',
  financialIn30days: 'Tài chính trong 30 ngày gần đây',
  financialInMonth: 'Tài chính tháng này',
  orFastLoginWith: 'Hoặc đăng nhập với Google, Apple',
  fontSize: 'Cỡ chữ',
  changeFontSizeWarning: 'Cỡ chữ đã được thay đổi. Bạn nên thoát ứng dụng vào lại để ứng dụng hoạt động ổn định',
  fontSizeList: ['Rất nhỏ', 'Nhỏ', 'Vừa', 'Lớn', 'Rất lớn', 'Rất rất lớn'],
  contact: 'Danh bạ',
  cause: 'Lý do',
  default: 'Mặc định',
  manager: 'Quản lý',
  paymentMethod: 'Phương thức thanh toán',
  closeWarning: 'Bạn có chắc chắn muốn tắt chức năng năng này không?',
  paymentMethodList: ['Tiền mặt', 'Chuyển khoản', 'Ghi nợ'],
  printerVideoDemo: 'Video hướng dẫn kết nối',
  supportWarning: 'Nếu cần hỗ trợ vui lòng liên hệ qua kênh Facebook cho team phát triển. \nCảm ơn bạn đã đồng hành!',
  offlineWarning:
    'Bạn đang sử dụng offline. Bạn nên đăng ký 1 tài khoản sử dụng online để tránh mất dữ liệu và có thể sử dụng nhiều tính năng khác cũng như có thể sử dụng phiên bản trên máy tính.',
  updating: 'Đang cập nhật',
  loadingData: 'Đang chuẩn bị dữ liệu',
  loadingHint: 'Hệ thống đang xử lý, vui lòng đợi trong giây lát...',
  remain: 'Còn lại',
  choiceProductTypeWarning: 'Vui lòng chọn phân loại hàng hóa',
  choiceProductUnitConvertWarning: 'Vui lòng chọn dơn vị của hàng hóa',
  editProduct: 'Sửa hàng hóa',
  onlyOnlineSupport: 'Tính năng chỉ hỗ trợ online. Vui lòng đăng nhập tài khoản để sử dụng chức năng này!',
  createBy: 'Tạo bởi',
  userName: 'Tên đăng nhập',
  fullName: 'Họ và tên',
  webVersion: 'Phiên bản web (máy tính)',
  webVersionBackup: 'Web dự phòng',
  syncingProgress: 'Đồng bộ đang diễn ra. Xin vui lòng đợi 1 - 15phút. Chúng tôi sẽ gửi một email cho bạn khi quá trình diễn ra hoàn tất',
  bulkDelete: 'Xóa hàng loạt',
  sync: 'Đồng bộ',
  offline: 'Offline',
  offlineNotSupport: 'Chỉ hỗ trợ bản online',
  warning: 'Cảnh báo',
  back: 'Trở về',
  yes: 'Có',
  no: 'Không',
  refresh: 'Làm mới',
  tryAgain: 'Thử lại',
  home: 'Trang chủ',
  language: 'Ngôn ngữ',
  theme: 'Giao diện',
  dark: 'Tối',
  light: 'Sáng',
  total: 'Tổng',
  quantity: 'Số lượng',
  totalMoney: 'Tổng tiền',
  paid: 'Đã thanh toán',
  totalDebit: 'Tổng còn nợ',
  totalReminder: 'Tổng còn dư',
  totalOldDebit: 'Nợ cũ',
  totalOldReminder: 'Số dư cũ',
  blanceAndDebt: 'Dư/nợ',
  debit: 'Còn nợ',
  remainder: 'Còn dư',
  arrears: 'Còn lại',
  status: 'Trạng thái',
  create: 'Thêm mới',
  add: 'Thêm',
  save: 'Lưu',
  saveImage: 'Lưu ảnh',
  next: 'Tiếp tục',
  print: 'In',
  oldPrint: 'In Bill (Đơn giản)',
  export: 'Xuất hoá đơn',
  edit: 'Sửa',
  copy: 'Sao chép',
  copied: 'Đã sao chép!',
  delete: 'Xoá',
  update: 'Cập nhật',
  updateStatus: 'Cập nhật trạng thái',
  day: 'Ngày',
  month: 'Tháng',
  year: 'Năm',
  from: 'Từ',
  to: 'Đến',
  fromDate: 'Từ ngày',
  toDate: 'Đến ngày',
  choiceImage: 'Chọn ảnh',
  exist: 'đã tồn tại',
  invalidParams: 'Vui lòng nhập đủ dữ liệu có dấu sao',
  success: 'Thành công',
  fail: 'Thất bại',
  all: 'Tất cả',
  complete: 'Hoàn thành',
  pending: 'Đang chờ',
  canceled: 'Đã huỷ',
  cancel: 'Huỷ bỏ',
  ok: 'Đồng ý',
  or: 'hoặc',
  choice: 'Chọn',
  confirm: 'Xác nhận',
  confirmExitApp: 'Bạn có muốn thoát khỏi ứng dụng?',
  time: 'Thời gian',
  notFound: 'Không tìm thấy dữ liệu. Vui lòng thử lại!',
  createdAt: 'Ngày tạo',
  none: 'Không có',
  detail: 'Chi tiết',
  filter: 'Lọc',
  filterByTim: 'Lọc theo thời gian',
  note: 'Ghi chú',
  trial: 'Dùng thử',
  option: 'Tùy chọn',
  notify: 'Thông báo',
  understand: 'Đã rõ',
  exportToExcel: 'Xuất Excel',
  multiHidden: 'Ẩn hàng loạt',
  multiActive: 'Kích hoạt hàng loạt',
  hiddenList: 'Danh sách ẩn',
  showList: 'Danh sách kích hoạt',
  importDataFromExcel: 'Nhập từ Excel',
  describe: 'Mô tả sản phẩm',
  addImage: 'Thêm ảnh',
  limitUpload: 'Mỗi sản phẩm hỗ trợ tối đa 5 ảnh',
  limitFeature: {
    intro: 'Bạn hãy trải nghiệm hoàn toàn miễn phí. Và hãy trả phí khi bạn thực sự thấy cần thiết',
    free: 'Phiên bản miễn phí',
    pro: 'Phiên bản cao cấp',
    title: 'Bạn cần mua phiên bản cao cấp để sử dụng tính năng này',
    package: 'Các gói quản lý cao cấp',
    packageOther: 'Các gói dịch vụ khác',
    features: [
      'Không có quảng cáo',
      'Không giới hạn hàng hoá',
      'Không giới hạn đơn hàng',
      'Tính năng in mã vạch sản phẩm (trên phiên bản web)',
      'Tính năng tích điểm cho khách hàng',
      'Tính năng sao chép đơn hàng',
      'Tính năng phụ phí người bán phải trả',
      'Tính năng trả hàng',
      'Tính năng ẩn hàng hóa cũ',
      'Tính năng phân loại hàng hóa (VD: Sp quần jean có phân loại size M, L, XL)',
      'Tính năng nhập, xuất dữ liệu ra file Excel',
      'Tính năng thêm phiếu thu, phiếu chi',
      'Tính năng thêm phiếu nợ cũ cho khách hàng',
      'Tính năng tạo phiếu xuất kho',
      'Tính năng tạo phiếu xuất kho',
      'Tính năng tạo mã QR thanh toán trực tiếp cho đơn hàng',
      'Tính năng đơn nháp (tạo đơn khi ko có kết nối mạng)',
      'Mỗi sản phẩm được up tối đa 5 ảnh',
      'Không giới hạn sử dụng phiên bản web (Máy tính)'
    ],
    freeFeatures: [
      'Có hiển thị quảng cáo',
      'Giới hạn 100 hàng hóa.',
      'Giới hạn 2.000 đơn hàng.',
      'Tính năng ẩn hàng hóa cũ',
      'Tính năng phụ phí người bán phải trả',
      'Tính năng trả hàng',
      'Tính năng in mã vạch của sản phẩm',
      'Tính năng tích điểm khách hàng',
      'Tính năng phân loại hàng hóa',
      'Tính năng in hoặc xuất hóa đơn',
      'Tính năng xuất ra excel',
      'Ttính năng thêm phiếu thu chi',
      'Tính năng thêm phiếu nợ',
      'Tính năng nhập hàng hóa, khách hàng từ file excel',
      'Tính năng tạo phiếu xuất kho',
      'Tính năng quy đổi đơn vị',
      'Giới hạn 1 ảnh trên 1 mặt hoá',
      'Giới hạn tính năng tạo mã QR thanh toán',
      'Miễn phí 3 tháng sử dụng phiên bản web'
    ]
  },
  syncDetail: {
    text1: 'Đồng bộ dữ liệu từ thiết bị lên tài khoản của bạn. Quá trình này chỉ cần thực hiện 1 lần duy nhất.',
    text2: 'Mỗi tài khoản chỉ có thể đồng bộ 1 lần thành công duy nhất',
    text3: 'Chức năng này vẫn đang trong quá trình thử nghiệm. Nếu gặp lỗi, xin vui lòng phản hồi với nhà phát triển để được hỗ trợ sớm nhất.',
    start: 'Bắt đầu đồng bộ',
    sendErrorData: 'Gửi dữ liệu lỗi',
    feedback: 'Phản hồi với nhà phát triển',
    sure: 'Bạn có chắc chắn muốn đồng bộ dữ liệu với tài khoản này?',
    syncedError: 'Tài khoản này đã được đồng bộ rồi',
    syncedAlert: 'Tài khoản này của bạn chưa đồng bộ dữ liệu offline. Bạn có muốn đồng bộ ngay ko?'
  },
  account: {
    switch: 'Chuyển tài khoản',
    switchConfirm: 'Bạn có chắc chắn muốn chuyển sang tài khoản %s không?',
    switchDeleteConfirm: 'Bạn có chắc chắn muốn xoá phiên đăng nhập của tài khoản %s không?',
    requiredInfo: 'Vui lòng nhập đầy đủ thông tin',
    enterCodeRequired: 'Vui lòng nhập mã xác nhận',
    enterPasswordRequired: 'Vui lòng nhập đầy đủ mật khẩu',
    passwordNotMatch: 'Hai mật khẩu không giống nhau',
    loginSubtitle: 'Chào mừng bạn quay trở lại!',
    systemSmartSubtitle: 'Hệ thống quản lý bán hàng thông minh',
    registerSubtitle: 'Tham gia cùng chúng tôi ngay hôm nay!',
    noAccountYet: 'Chưa có tài khoản?',
    alreadyHaveAccount: 'Đã có tài khoản?',
    forgotPasswordStepEmail: 'Nhập email của bạn để bắt đầu khôi phục mật khẩu.',
    forgotPasswordStepCode: 'Vui lòng kiểm tra mã xác thực 6 số đã được gửi tới email.',
    forgotPasswordStepPassword: 'Sử dụng một mật khẩu mạnh để bảo vệ tài khoản của bạn.',
    backToLogin: 'Quay lại đăng nhập',
    sendCodeSuccess: 'Chúng tôi đã gửi một email bao gồm mã code. Vui lòng kiểm tra email để lấy mã code xác nhận',
    errorCode: 'Mã xác nhận không chính xác',
    codeExpired: 'Mã xác nhận đã hết hạn.',
    forgotPassword: 'Quên mật khẩu',
    enterEmail: 'Nhập email của bạn',
    enterCode: 'Nhập mã xác nhận',
    sendCode: 'Gửi mã xác nhận',
    submitCode: 'Xác nhận',
    changePassword: 'Thay đổi mật khẩu',
    newPassword: 'Mật khẩu mới',
    renewPassword: 'Mật lại khẩu mới',
    password: 'Mật khẩu',
    repassword: 'Nhập lại mật khẩu',
    register: 'Đăng ký',
    inputSoShort: 'Tên đăng nhập hoặc mật khẩu quá ngắn',
    repassWrong: 'Mật khẩu nhập lại không đúng',
    emailExist: 'Email đã tồn tại',
    logout: 'Đăng xuất',
    login: 'Đăng nhập',
    loginWithoutEmail: 'Đăng nhập không cần email',
    loginWithoutEmailError: 'Lỗi không thể tạo mã thiết bị. Vui lòng liên hệ hỗ trợ để được hướng dẫn!',
    offlineMode: 'Sử dụng offline',
    offlineModeWarning: 'Khi sử dụng offline, dữ liệu sẽ được lưu ở thiết bị của bạn. Bạn cần đăng nhập trước khi chuyển sang thiết bị khác mà không bị mất dữ liệu',
    offlineDeprecated:
      'Kể từ ngày 13/3/2025. Ứng dụng này ko hỗ trợ chức năng offline nữa. \nĐể sử dụng offline miễn phí. Bạn hãy tải ứng dụng aSeller Offline (Ứng dụng có icon màu cam).\nXin cảm ơn!',
    logoutConfirmMessage: 'Bạn có chắc chắn muốn đăng xuất tài khoản này?',
    notFoundEmail: 'Không tìm thấy tài khoản với email này',
    errorPassword: 'Mật khẩu không chính xác',
    emailInvalid: 'Email không đúng định dạng',
    titleRequest: 'Chúng tôi đã nhận được yêu cầu thay đổi mật khẩu được liên kết với email này.',
    enterCodeEmail: 'Nhập mã xác minh được gửi tới email của bạn. Nếu không tìm thấy, vui lòng kiểm tra trong mục thư rác hoặc spam trên ứng dụng email của bạn.'
  },
  schedule: {
    title: 'Quản lý Schedule',
    add: 'Thêm Schedule',
    requiredInfo: 'Vui lòng điền đầy đủ thông tin',
    updateError: 'Lỗi cập nhật schedule',
    createError: 'Lỗi tạo schedule',
    updateSuccess: 'Cập nhật schedule thành công',
    createSuccess: 'Tạo schedule mới thành công',
    deleteError: 'Lỗi xoá schedule',
    deleteSuccess: 'Xoá schedule thành công',
    pending: 'Đang chờ',
    completed: 'Đã hoàn thành',
    name: 'Tên',
    value: 'Giá trị',
    time: 'Thời gian',
    status: 'Trạng thái',
    action: 'Hành động',
    edit: 'Sửa',
    editTitle: 'Sửa Schedule',
    createTitle: 'Tạo Schedule Mới',
    namePlaceholder: 'Nhập tên schedule',
    valuePlaceholder: 'Nhập giá trị',
    deleteTitle: 'Xoá schedule',
    deleteConfirm: 'Bạn có chắc muốn xoá schedule này?'
  },
  statitical: {
    chart: 'Biểu đồ',
    title: 'Báo cáo & Thống kê',
    sale: 'Doanh số',
    debtBook: 'Sổ ghi nợ',
    revenue1: 'Doanh thu',
    revenue: 'Lợi nhuận',
    profit: 'Lợi nhuận',
    capital: 'Giá vốn',
    costOfCapital: 'Chi phí vốn',
    expense: 'Chi phí',
    saleToday: 'Hôm nay',
    sale7Days: '7 ngày',
    sale30Days: '30 ngày',
    chart7Days: 'Biểu đồ 7 ngày gần đây',
    saleTitle: 'Thống kê doanh số',
    revenueTitle: 'Thống kê lợi nhuận',
    orderTitle: 'Thống kê đơn hàng',
    returnOrderTitle: 'Thống kê đơn trả hàng',
    order: 'Đơn hàng',
    stock: 'Thống kê kho',
    quantityOfInventory: 'Hàng tồn kho theo đơn vị',
    quantityOfInventoryByCategory: 'Hàng tồn kho theo danh mục',
    inventoryCapital: 'Vốn tồn kho',
    inventoryCapitalDetail: '(Tính tương đối theo giá vốn thời điểm hiện tại)',
    quantityOfInventoryProduct: 'Hàng hóa tồn kho nhiều nhất',
    saleOfStaff: 'Doanh số của nhân viên',
    choiceToView: 'Hãy chọn loại báo cáo và thời gian để xem chi tiết thông tin hơn',
    choiceType: 'Loại báo cáo',
    oldStaticWarning: 'Báo cáo đã cập nhật số liệu chuẩn theo múi giờ của bạn.'
  },
  menu: {
    category: 'Danh mục',
    statitical: 'Báo cáo & Thống kê',
    oldStatitical: 'Thống kê (cũ)',
    version: 'Phiên bản',
    other: 'Khác',
    setting: 'Cài đặt',
    shortcut: 'Lối tắt',
    account: 'Tài khoản',
    feedback: 'Phản hồi & góp ý',
    share: 'Gửi app này cho bạn bè',
    reportBug: 'Gửi dử liệu báo cáo lỗi',
    reportLogBug: 'Gửi nhật ký lỗi',
    policy: 'Chính sách bảo mật',
    term: 'Điều khoản sử dụng',
    editProfile: 'Cập nhật thông tin',
    editProfileDetail: 'Cập nhật thông tin cửa hàng để thông tin hiển thị đầy đủ trên hóa đơn.',
    orderReturn: 'Đơn trả hàng',
    support: 'Hỗ trợ'
  },
  settingForStaff: {
    title: 'Cài đặt cửa hàng',
    staff: 'Nhân viên',
    staffApp: 'Ứng dụng aSeller khác',
    branch: 'Khu vực',
    branchHint: 'Mục này chỉ dành cho giao diện kinh doanh dịch vụ. VD tầng 1, tầng 2...',
    cafe: 'Cafe & Nhà hàng',
    passForStaff: 'Mật khẩu dành cho nhân viên',
    passForStaffDetail: 'Mật khẩu riêng dành cho nhân viên đăng nhập trên ứng dụng bán hàng. Đừng để giống mật khẩu chính',
    mainBranch: 'Chính',
    addBranch: 'Thêm khu vực',
    editBranch: 'Sửa khu vực',
    addStaff: 'Thêm nhân viên',
    editStaff: 'Sửa nhân viên',
    table: 'Bàn',
    branchName: 'Tên khu vực',
    branchTable: 'Số lượng bàn',
    staffs: 'Quản lý nhân viên',
    staffsDetail: 'Mỗi cửa hàng sẽ được miễn phí 1 tháng cho 1 nhân viên đầu tiên.',
    addStaffSubtitle: 'Khởi tạo tài khoản mới cho nhân viên',
    editStaffSubtitle: 'Cập nhật tài khoản nhân viên',
    accountInfo: 'Thông tin tài khoản',
    personalInfo: 'Thông tin cá nhân',
    placeholderUserName: 'Tên đăng nhập...',
    placeholderPasswordEdit: 'Bỏ trống nếu không đổi',
    placeholderPassword: 'Mật khẩu...',
    placeholderFullName: 'Họ và tên...',
    placeholderPhone: 'SĐT...',
    placeholderAddress: 'Địa chỉ...',
    placeholderNote: 'Ghi chú về nhân viên...',
    emptyStaff: 'Chưa có nhân viên.',
    upgradeStaff: 'Gia hạn',
    appForStaffIntro:
      'Danh sách ứng dụng cho nhân viên, nhân viên của bạn có thể dùng ứng dụng này để tạo đơn hàng. Bạn sẽ cần tạo tài khoản nhân viên để sử dụng. Dữ liệu sẽ được đồng bộ sang tài khoản chính của bạn.',
    emailExist: 'Tên đăng nhập đã tồn tại',
    shopType: 'Loại kinh doanh',
    grocery: 'Tạp hóa, Siêu thị',
    appForStaff: ['Nhân viên aSeller bán hàng'],
    appForStaffDetail: ['Ứng dụng này dành cho nhân viên. Bạn có thể tạo tài khoản nhân viên trong mục "Quản lý nhân viên - Thêm"'],
    shopTypeDetail: 'Chọn loại kinh doanh phù hợp để sử dụng giao diện phù hợp trên ứng dụng bán hàng cho nhân viên',
    showCustomer: 'Hiển thị khách hàng cho nhân viên',
    showCustomerDetail: 'Hiển thị danh sách khách hàng trên ứng dụng của nhân viên',
    customerShowMode: ['Hiển thị tất cả', 'Chỉ khách của nhân viên', 'Không hiển thị'],
    upgradeStaffContact: 'Để gia hạn cho nhân viên. Vui lòng liên hệ',
    service: 'Dịch vụ',
    serviceDetail: 'Quán xá, cafe, trà sữa, nhà hàng...',
    retail: 'Bán nhanh',
    retailDetail: 'Tạp hóa, siêu thị...',
    showStatistial: 'Hiển thị doanh số tuần',
    showStatistialDetail: 'Cho phép nhân viên xem doanh số 7 ngày gần nhất',
    stockEnabled: 'Hiển thị tồn kho cho nhân viên',
    stockEnabledDetail: 'Hiển thị số tồn kho, số lượt bán trên app nhân viên',
    uiForStaft: 'Giao diện bán hàng cho nhân viên',
    uiForStaftDetail: 'Lựa chọn giao diện thích hợp để thuận tiện nhất cho nhân viên của bạn',
    typeCafe: 'Có danh sách các bàn để theo dõi thuận tiện. Phù hợp cho hình thức kinh doanh nhà hàng, quán, tiệm, cafe, trà tranh... ',
    typeRetail: 'Giao diện đơn giản. Phù hợp với hình thức bán sỉ lẻ, chỉ cần giao diện đơn giản nhưng hiệu quả.',
    typeSalesCounter: 'Giao diện đứng quầy. Phù hợp cho nhân viên đứng quầy, chuyên nghiệp và hiệu quả',
    counter: 'Quầy',
    productList: 'Danh sách sản phẩm',
    productListDetail: 'Cài đặt danh sách sản phẩm hiển thị cho từng nhân viên. Mặc định sẽ hiển thị tất cả sản phẩm',
    tableManager: 'Order bàn'
  },
  prefix: {
    title: 'Tiền tố',
    detail: 'Chuỗi ký tự xuất hiện trước mã của đơn hàng, hàng hóa,... VD mã đơn hàng: HD123'
  },
  setting: {
    advanced: 'Nâng cao',
    customerCanRegister: 'Cho phép khách hàng đăng ký tài khoản',
    customerCanRegisterDetail: 'Khách hàng có thể tự đăng ký tài khoản. Khách hàng có thể theo dõi đơn hàng, hoá đơn của họ.',
    vote: 'Đánh giá ứng dụng!',
    about: 'Giới thiệu',
    title: 'Cài đặt chung',
    help: 'Hướng dẫn sử dụng',
    currency: 'Đơn vị tiền tệ',
    timeFormat: 'Định dạng ngày',
    oddNumber: 'Sử dụng đơn vị số lẻ',
    oddNumberEx: 'VD 1000.15VNĐ, 0.5KG...',
    sync: 'Dữ liệu',
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    notSignin: 'Chưa đăng nhập',
    syncIntro: 'Đăng nhập tài khoản Google của bạn để sao lưu giúp dữ liệu của bản được bảo toàn, và có thể chuyển qua thiết bị khác',
    syncNow: 'Sao lưu ngay',
    lastSync: 'Sao lưu lần cuối lúc',
    restore: 'Khôi phục dữ liệu',
    requireLogin: 'Bạn cần đăng nhập tài khoản Google để thực hiện chức năng này',
    syncNotFound: 'Không tìm thấy bản sao lưu nào',
    confirmSync: 'Dữ liệu trên máy chủ sẽ bị ghi đè. Bạn có chắc chắn muốn đồng bộ dữ liệu ko?',
    confirmRestore: 'Bạn có chắc chắn muốn khôi phục dữ liệu, dữ liệu hiện tại sẽ bị ghi đè?',
    loginExpired: 'Phiên đăng nhập hết hạn. Vui lòng đăng nhập lại!',
    autoBackup: 'Tự động sao lưu dữ liệu',
    googleAccountConnect: 'Tài khoản Google',
    on: 'Bật',
    off: 'Tắt',
    googleLogoutConfirm: 'Bạn có chắc chắn muốn thoát tài khoản Google này ko?',
    print: 'Kết nối máy in',
    printDetail: 'Chọn máy in bluetooth của bạn để kết nối và in hóa đơn của hàng hóa',
    connectPrinter: 'Máy in',
    invoice: 'Hóa đơn',
    invoiceHello: 'Lời cảm ơn',
    surchargeText: 'Thay đổi chữ phụ phí trên hóa đơn',
    invoiceSignature: 'Hiển thị chữ ký',
    invoiceDebt: 'Hiển thị dư nợ',
    invoiceDebtInfo: 'Hiển thị số dư nợ trong chi tiết đơn hàng',
    debt: 'Dư nợ',
    invoiceDebtDetail: 'Dư nợ chi tiết',
    invoiceDebtDetailDetail: 'Hiển thị mặt hàng chi tiết trong phiếu nợ phiên bản rút gọn',
    invoiceDiscount: 'Hiển thị % giảm giá',
    invoiceHelloDetail: 'Chỉnh sửa lời cảm ơn tới khách hàng bên dưới hóa đơn',
    warningOutStock: 'Cảnh báo hết hàng',
    warningOutStockDetail: 'Khi hết hàng sẽ ko thể thêm vào đơn hàng',
    warningOutStockMessage: 'Hàng hóa này của bạn đã hết. Vui lòng nhập thêm hoặc tắt cảnh báo này trong cài đặt',
    showRevenue: 'Hiển thị lợi nhuận',
    orderStatus: 'Hiển thị trạng thái đơn hàng',
    orderStatusDetail: 'Hiển thị trạng thái "Đang chờ" hoặc "Hoàn thành". Nếu bật sẽ không thể tạo phiếu thu cho đơn hàng.',
    showHomeRevenue: 'Hiển thị lợi nhuận',
    showHomeChart: 'Hiển thị biểu đồ',
    showHomeFinancial: 'Hiển thị tài chính',
    showHomeStatistial: 'Hiển thị thống kê',
    averageBuyPrice: 'Giá vốn trung bình',
    averageBuyPriceDetail:
      'Giá vốn được tự động tính trung bình sau mỗi lần nhập hàng để tính toán lợi nhuận chính xác hơn.\nCông thức = (Tổng tiền tồn kho hiện tại + Số tiền nhập kho mới)/(Tổng số lượng)',
    bankInfo: 'Tài khoản ngân hàng',
    vietQRCode: 'Mã QR Thanh toán',
    vietQRCodeDetail: 'Mã VietQR quét để thanh toán nhanh. Trong đó có thông tin số tiền đơn hàng, nội dung chuyển khoản.',
    vietQRCodeWarning: 'Vui lòng nhập chính xác thông tin tài khoản. Chúng tôi sẽ không chịu trách nhiệm nếu thông tin của bạn nhập không chính xác!',
    bankName: 'Tên ngân hàng',
    bankAcc: 'Số tài khoản',
    bankAccName: 'Tên chủ tài khoản',
    bankTransferContent: 'Nội dung chuyển khoản',
    showSurchargeShopPay: 'Hiển thị phụ phí shop trả',
    showSurchargeShopPayDetail: 'Nếu không chọn thì phụ phí người bán trả sẽ không hiển thị trên bill, hoá đơn',
    debtActive: 'Kích hoạt công nợ',
    debtActiveDetail:
      'Kích hoạt công nợ để theo dõi công nợ cho khách hàng. Nếu bạn tắt những chức năng liên quan đến công nợ (VD: phiếu thu chi cho đơn hàng, phiếu thu chi khách hàng, sổ ghi nợ...) sẽ không hoạt động.',
    debtInactiveDetail: 'Chức năng công nợ đã bị tắt. Để kích hoạt vui lòng vào "Cài đặt" -> "Cài đặt đơn hàng" -> "Kích hoạt dư nợ"',
    inventoryActive: 'Kích hoạt theo dõi tồn kho',
    inventoryActiveDetail:
      'Theo dõi số lượng hàng tồn trong kho. Nếu bị tắt, tất cả những tính năng liên quan đến tồn kho sẽ không hoạt động.\nNếu bạn kinh doanh dịch vụ như quán cafe, nhà hàng... thì nên tắt chức năng này để đơn giản hoá quá trình sử dụng.',
    inventoryInactiveDetail: 'Tính năng này không hoạt động khi bạn tắt theo dõi hàng tồn kho. Để kích hoạt vui lòng vào "Cài đặt" -> "Cài đặt hàng hoá" -> "Kích hoạt tồn kho".',
    inventoryActiveWarning: 'Nếu bạn tắt thì tất cả những chức năng liên quan đến tồn kho sẽ không hoạt động. Bạn có chắc chắn muốn tắt kích hoạt không?'
  },
  customer: {
    id: 'Mã khách',
    prefix: 'Tiền tố mã khách hàng',
    title: 'Khách hàng',
    create: 'Thêm khách hàng',
    name: 'Tên khách hàng',
    address: 'Địa chỉ',
    phone: 'SĐT',
    email: 'Email',
    add: 'Thêm mới khách hàng',
    choice: 'Chọn khách hàng',
    invalidPhoneOrAddress: 'Vui lòng nhập số điện thoại hoặc địa chỉ',
    phoneExist: 'Số điện thoại này đã tồn tại',
    search: 'Tìm theo tên, sđt, mã số thuế, căn cước...',
    free: 'Khách lẻ',
    freeDetail: 'Khách hàng vãng lai',
    orderStatistics: 'Thống kê đơn hàng',
    exportDebt: 'Xuất phiếu nợ',
    addDebt: 'Thêm phiếu nợ',
    yearOld: 'Tuổi',
    countBirthDay: 'Còn %s ngày',
    taxCode: 'Mã số thuế',
    citizenId: 'Mã số định danh',
    exportOrderExcel: 'Xuất Excel danh sách đơn hàng',
    purchasedProducts: 'Hàng đã mua',
    taxCodeHint: 'Có thể tìm kiếm tổ chức theo mã số thuế',
    createScreen: {
      taxCodeNotFound: 'Không tìm thấy thông tin mã số thuế',
      avatarLabel: 'Ảnh đại diện',
      contactHint: 'Điền nhanh thông tin từ danh bạ hoặc thêm ảnh đại diện',
      basicInfoTitle: 'Thông tin cơ bản'
    },
    deleteWarning: 'Bạn có chắc chắn muốn xoá khách hàng này không? Tất cả đơn hàng, phiếu thu chi liên quan đến khách hàng này sẽ bị chuyển về khách lẻ.'
  },
  order: {
    lastPrice: 'Giá gần nhất',
    lastPriceAuto: 'Tự động dùng giá bán gần nhất',
    lastPriceAutoDetail: 'Đơn bán cho khách sẽ tự động lấy giá bán gần nhất của khách đó thay vì giá bán lẻ',
    addDisplayInfo: 'Thêm thành phần hiển thị',
    editDeadline: 'Thời hạn chỉnh sửa đơn hàng',
    editDeadlineDetail: 'Cho phép chỉnh sửa đơn hàng trong vòng số ngày này kể từ ngày tạo đơn.',
    editDeadlineExpired: 'Đơn hàng đã quá thời hạn chỉnh sửa. Vui lòng cài đặt lại thời gian cho phép sửa đơn hàng trong "Cài đặt" -> "Cài đặt đơn hàng".',
    summary: 'Tóm tắt đơn hàng',
    id: 'Mã đơn',
    prefix: 'Tiền tố mã đơn hàng',
    title: 'Đơn bán hàng',
    create: 'Thêm đơn bán',
    edit: 'Sửa đơn hàng',
    detail: 'Chi tiết đơn hàng',
    exportInvoice: 'Hoá đơn thanh toán',
    add: 'Thêm sản phầm',
    infoShop: 'Thông tin shop',
    invalidCustomer: 'Vui lòng chọn thông tin khách hàng',
    invalidProduct: 'Chưa có hàng hóa nào trong đơn hàng',
    confirmDelete: 'Bạn có chắc chắn muốn xoá %s này?',
    search: 'Lọc theo mã đơn hàng, tên hoặc số đt khách hàng',
    discount: 'Chiết khấu',
    realPrice: 'Giá thực tính',
    discount1: 'Giảm giá (Chiết khấu)',
    inStockNotEnough: 'Số lượng hàng hóa trong kho không đủ. Vui lòng nhập thêm hàng hóa, hoặc cập nhật số lượng trong kho.',
    createFailed: 'Tạo đơn hàng thất bại. Vui lòng thử lại hoặc phản hồi với nhà phát triển.',
    surcharge: 'Phụ phí',
    surchargeDetail: '(ship, thuế, nợ cũ...)',
    barcodeNotFound: 'Mã barcode này chưa tồn tại. Mời bạn nhập vào hàng hóa trước khi thêm vào dơn hàng',
    price: 'Giá',
    customPrice: 'Giá tùy chỉnh',
    customPrice1: 'Giảm theo %',
    orderMoneyUpdated: 'Giá trị của đơn hàng được cập nhật lại do giá bán thay đổi',
    totalProductMoney: 'Tổng tiền hàng',
    totalMustPaidMoney: 'Tổng phải trả',
    totalMustPaidMoneyForCustomer: 'Tổng phải trả lại khách',
    totalPaidMoney: 'Đã thanh toán',
    totalDebtMoney: 'Khách còn nợ',
    paid: 'Đã thanh toán',
    totalLiabilities: 'Tổng còn nợ',
    totalPaidMoneyForCustomer: 'Trả lại khách',
    providerRefunds: 'Nhà cung cấp trả lại',
    providerDebt: 'Còn nợ nhà cung cấp',
    pointDiscount: 'Giảm trừ điểm tích lũy',
    money: 'Tổng tiền đơn hàng',
    statusOffRequire: 'Tắt trạng thái đơn hàng',
    statusOffRequireDetail:
      'Để tạo phiếu thu cho đơn hàng. Bạn phải tắt trạng thái đơn hàng đi vì nó có thể gây nhầm lẫn khi về số dư nợ của đơn hàng. Bạn chắc chắn muốn tắt trạng thái đơn hàng để sử dụng chức năng này chứ?',
    surchargeType2: 'Người bán trả',
    surchargeType1: 'Người mua trả',
    surchargeTypeHint:
      '- Người mua trả: Sẽ được tính vào tiền đơn hàng, tính vào doanh thu, không tính vào lợi nhuận.\n- Người bán trả: Sẽ ko tính vào tiền đơn hàng, sẽ tạo 1 phiếu chi tương ứng để tính vào chi phí của cửa hàng',
    table: 'Bàn',
    changeTable: 'Đổi bàn',
    changeTableInput: 'Nhập số bàn cần đổi',
    separate: 'Tách món',
    separateDetail: ' Tách một hàng hoá ra nhiều dòng trong cùng 1 đơn bán hàng',
    promotionAuto: 'Tự động áp dụng khuyến mại',
    promotionAutoDetail: 'Tự động áp dụng khuyến mại bạn chọn gần nhất cho đơn hàng',
    emptyProduct: 'Vui lòng thêm món hàng',
    draftOrderWarning: 'Lưu ý: Đây là hoá đơn tạm tính, chưa được lưu vào dữ liệu.',
    draftSaved: 'Đã lưu đơn nháp. Vui lòng kiểm tra danh sách đơn nháp ở "Trang chủ"',
    vatDetail: 'Thuế(VAT) được tự động tính từ VAT của hàng hoá. Chức năng này đã quá cũ, bạn nên sử dụng chức năng thuế(VAT) trên hàng hoá để có kết quả chính xác hơn.',
    productSorting: 'Sắp xếp hàng hoá trong đơn hàng',
    productSortingDetail: 'Hàng hoá thêm vào sau sẽ hiển thị cuối danh sách. Bỏ kích hoạt sẽ hiển thị đầu danh sách',
    description: 'Quản lý và theo dõi tất cả các đơn bán hàng của bạn.'
  },
  product: {
    multiStopSale: 'Ngừng bán hàng loạt',
    multiSale: 'Kinh doanh hàng hoá hàng loạt',
    stopSale: 'Ngừng bán',
    sale: 'Kinh doanh',
    stopSaleList: 'Danh sách ngừng bán',
    saleList: 'Danh sách đang bán',
    product: 'Sản phẩm',
    id: 'Mã hàng hóa',
    prefix: 'Tiền tố mã hàng hóa',
    title: 'Hàng hóa',
    create: 'Thêm hàng hóa',
    add: 'Thêm hàng hóa',
    choice: 'Chọn hàng hóa',
    name: 'Tên hàng hóa',
    priceType: 'Chọn giá',
    price: 'Giá hàng hóa',
    buyPrice: 'Giá vốn',
    sellPrice: 'Giá bán lẻ',
    sellPrice1: 'Giá khuyến mại',
    sellPrice2: 'Giá bán sỉ',
    recent: 'Sản phầm thêm gần đây',
    search: 'Lọc theo mã, tên hàng hóa',
    sold: 'Đã bán',
    inStock: 'Tồn kho',
    initStock: 'Số lượng ban đầu',
    initStockDetail: 'Số lượng tồn kho ban đầu khi tạo sản phẩm mới',
    vatDetail: 'Thuế được tính vào đơn bán',
    vat: 'Thuế (VAT)',
    expirationDate: 'Ngày hết hạn',
    outOfStock: 'Hết hàng',
    barcode: 'Mã code',
    exist: 'Hàng hóa đã tồn tại. Vui lòng kiểm tra lại tên hoặc mã barcode',
    canNotDelete: 'Bạn không thể xóa hàng hóa này vì hàng hóa đã có trong đơn hàng. Vui lòng xóa đơn hàng trước.',
    errorPrice: 'Giá bán hoặc giá vốn ko hợp lệ',
    changeSellPriceWarning: 'Lưu ý: Thay đổi giá bán sẽ ảnh huởng đến những đơn hàng hiện tại',
    changeSellPriceWarningDetail:
      'Thay đổi giá bán sẽ ảnh huởng đến những đơn hàng hiện tại, bạn sẽ phải cập nhật lại đơn hàng có chứa mặt hàng này. Bạn có chắc chắn muốn làm điều này ko?',
    deleteNumProduct: 'Xóa %s mặt hàng',
    deleteNumProductConfirm: 'Bạn có chắc chắn muốn xóa %s mặt hàng này không?',
    hiddenNumProduct: 'Ngừng bán %s mặt hàng',
    activeNumProduct: 'Kinh doanh %s mặt hàng',
    hiddenNumProductConfirm: 'Bạn có chắc chắn muốn ngừng bán %s mặt hàng này không?',
    activeNumProductConfirm: 'Bạn có chắc chắn muốn kinh doanh %s mặt hàng này không?',
    canNotDeleteProduct: 'Bạn không thể xóa %s mặt hàng vì nó đã có trong đơn hàng.',
    syncAmount: 'Đồng bộ số lượng hàng tồn với đơn nhập',
    syncAmountConfirm: 'Số lượng hàng tồn của mặt hàng này là %s. Bạn có muốn cập nhật lại ko?',
    barcodeExist: 'Mã barcode này đã tồn tại cho mặt hàng khác.',
    combo: 'Combo',
    comboProduct: 'Hàng combo',
    comboRecipe: 'Công thức combo',
    comboRecipeHint: 'Combo sẽ trừ tồn kho theo các mặt hàng con bên dưới.',
    comboSelectChild: 'Chọn hàng hóa con',
    comboAddChild: 'Thêm hàng hóa con',
    comboEmpty: 'Chưa có hàng hóa con trong công thức combo',
    comboQuantity: 'Số lượng trong combo',
    comboAutoBuyPrice: 'Giá vốn được tính tự động từ công thức combo',
    comboDerivedStock: 'Tồn kho tính theo hàng con',
    comboTypeLabel: 'Loại hàng hóa',
    comboTypeNormal: 'Hàng thường',
    comboTypeCombo: 'Hàng combo',
    comboSelectChildWarning: 'Vui lòng chọn hàng hóa con cho combo.',
    comboQuantityWarning: 'Số lượng của hàng hóa con phải lớn hơn 0.',
    comboDuplicateChildWarning: 'Một hàng hóa con chỉ được xuất hiện một lần trong công thức combo.',
    comboChildCannotBeCombo: 'Hàng hóa con không được là một combo khác.',
    comboSelfWarning: 'Combo không thể chứa chính nó.',
    comboVariantNotSupported: 'Combo chưa hỗ trợ dùng cùng biến thể. Vui lòng xóa biến thể trước khi chuyển sang combo.',
    simpleModeCombWarning: 'Vui lòng tạo hàng hoá đầy đủ trong danh sách hàng hoá',
    comboConvertToNormalBuyPriceWarning: 'Khi chuyển combo về hàng thường, vui lòng nhập lại giá vốn.',
    type: 'Biến thể',
    type1: 'Biến thể (Size, màu...)',
    typeHint: 'Tên biến thể',
    sku: 'Mã sku',
    skuExist: 'Mã sku này đã tồn tại. Vui lòng nhập mã khác!',
    image: 'Ảnh hàng hóa',
    nameSoShort: 'Tên sản phẩm phải lớn hơn 4 ký tự',
    nameExist: 'Tên sản phẩm đã tồn tại',
    canNotCreateUnitConvertWithType: 'Không thể tạo đơn vị chuyển đổi cho sản phẩm có biến thể.',
    limitUploadImage: 'Phiên bản miễn phí chỉ hỗ trợ 1 hình ảnh trên mỗi sản phẩm. Vui lòng nâng cấp để thêm nhiều ảnh hơn!',
    limitContentLength: 'Mô tả của sản phẩm phải dưới %s ký tự!',
    limitImageOffline: 'Phiên bản offline chỉ hỗ trợ 1 ảnh!',
    importNewFromExcel: 'Nhập sản phẩm mới',
    importUpdateFromExcel: 'Cập nhật sản phẩm hiện có',
    description: 'Quản lý và theo dõi tất cả hàng hóa của bạn.'
  },
  category: {
    id: 'Mã danh mục',
    prefix: 'Tiền tố mã danh mục',
    title: 'Danh mục hàng',
    create: 'Thêm danh mục',
    name: 'Tên danh mục',
    choice: 'Lựa chọn danh mục',
    search: 'Lọc theo mã, tên danh mục',
    categoryExist: 'Tên danh mục đã tồn tại',
    choiceProduct: 'Chọn hàng hóa để thêm vào danh mục',
    description: 'Quản lý và theo dõi tất cả danh mục của bạn',
    tips: 'Gợi ý',
    tip1: 'Sử dụng tên danh mục ngắn gọn, dễ hiểu (Ví dụ: Nước uống, Đồ ăn nhanh...).',
    tip2: 'Danh mục giúp việc phân loại và tìm kiếm sản phẩm nhanh chóng hơn.',
    tip3: 'Bạn có thể sắp xếp sản phẩm vào danh mục này ngay sau khi tạo xong.',
    itemsCountDesc: '%s sản phẩm hiện có trong danh mục này'
  },
  bestSelling: {
    title: 'Xu hướng tiêu dùng',
    subtitle: 'Sản phẩm bán chạy trong 30 ngày'
  },
  importOrder: {
    id: 'Mã đơn',
    prefix: 'Tiền tố mã đơn nhập',
    title: 'Đơn nhập hàng',
    detail: 'Chi tiết đơn nhập hàng',
    create: 'Thêm đơn nhập',
    edit: 'Sửa đơn nhập',
    editProductPrice: 'Thay đổi giá vốn',
    editProductPriceWarning: 'Bạn có muốn thay đổi giá vốn của hàng hóa này về %s ko?'
  },
  importReturnOrder: {
    id: 'Mã đơn',
    prefix: 'Tiền tố mã đơn trả nhà cung cấp',
    title: 'Đơn trả hàng nhập',
    detail: 'Chi tiết đơn trả hàng nhập',
    create: 'Thêm đơn trả hàng nhập',
    edit: 'Sửa đơn trả hàng nhập'
  },
  provider: {
    id: 'Mã nhà cung cấp',
    prefix: 'Tiền tố nhà cung cấp',
    title: 'Nhà cung cấp',
    create: 'Thêm nhà cung cấp',
    name: 'Tên nhà cung cấp',
    choice: 'Lựa chọn nhà cung cấp',
    search: 'Lọc theo mã, tên, sđt nhà cung cấp',
    categoryExist: 'Tên nhà cung cấp đã tồn tại',
    order: 'Đơn hàng',
    free: 'Không xác định',
    deleteWarning: 'Bạn có chắc chắn muốn xoá nhà cung cấp này không? Tất cả đơn hàng, phiếu thu chi liên quan đến nhà cung cấp này sẽ bị chuyển về "Không xác định".'
  },
  googleDriver: {
    loginGoogle: 'Bạn cần đăng nhập tài khoản Google để thực hiện chức năng này',
    backup: 'Sao lưu',
    backupToDriver: 'Sao lưu',
    backupSuccess: 'Sao lưu thành công',
    backupError: 'Sao lưu thất bại',
    emptyBackup: 'Không tìm thấy bản sao lưu nào',
    loadingBackupFile: 'Đang tải dữ liệu sao lưu',
    backingUp: 'Đang sao lưu',
    restore: 'Khôi phục',
    restoreFromDriver: 'Khôi phục',
    restoreSuccess: 'Khôi phục dữ liệu thành công',
    restoring: 'Đang khôi phục dữ liệu',
    resetData: 'Khởi tạo lại dữ liệu',
    resetDataDetail: 'Khởi tạo lại dữ liệu từ đầu',
    resetDataConfirm: 'Bạn có chắc chắn muốn xoá sạch dữ liệu hiện tại không?',
    backupErrorCaseInvalidToken: 'Không thể sao lưu dữ liệu do tài khoản Google của bạn đã hết phiên đăng nhập. Xin vui lòng đăng nhập và thử lại!',
    confirmReplaceOlderTitle: 'Xác nhận ghi đè',
    confirmReplaceOlderDetail: 'Chúng tôi tìm thấy phiên bản dữ liệu mới hơn trên Google Driver. Bạn có chắc chắn muốn sao lưu dữ liệu hiện tại không?',
    restoreChoose: 'Chọn dữ liệu bạn muốn khôi phục',
    backupRename: 'Chỉnh sửa lại tên dễ nhớ',
    backupAt: 'Sao lưu lúc'
  },
  staffUpgrade: {
    upgradeForStaff: 'Bạn đang gia hạn cho nhân viên. Nếu bạn đã thanh toán trước đó mà chưa được cập nhật. Bạn vui lòng chọn khôi phục thanh toán.',
    staff1m: 'Gia hạn thêm 1 tháng',
    staff6m: 'Gia hạn thêm 6 tháng',
    staff1y: 'Gia hạn thêm 1 năm'
  },
  proVersion: {
    pro: 'Gói lẻ cao cấp (VIP)',
    proDetail:
      'Gói cao cấp là gói sử dụng đầy đủ tính năng của ứng dụng (không bao gồm tài khoản nhân viên, và chi nhánh mở rộng). Vui lòng bấm "So sánh Miễn phí - Cao cấp" để biết thêm chi tiết.',
    staffAcc: 'Gói lẻ tài khoản nhân viên',
    staffAccDetail:
      'Gói dành cho cửa hàng doanh nghiệp muốn sử dụng tài khoản nhân viên. Miễn phí 1 tháng đầu cho 1 tài khoản nhân viên đầu tiên. Một tài khoản nhân viên có thể đăng nhập không giới hạn thiết bị.',
    warehouseExt: 'Gói lẻ chi nhánh mở rộng',
    warehouseExtDetail: 'Gói chi nhánh mở rộng áp dụng cho chi nhánh thứ 2 trở đi. Chi nhánh thứ 2 sẽ được miễn phí sử dụng một tháng. ',
    linked: 'Đã liên kết',
    paymentRecoveryHint: 'Vui lòng chọn thanh toán của bạn để khôi phục cho tài khoản này!',
    name: 'Phiên bản cao cấp',
    detail: 'Những thay đổi khi bạn mua gói phiên bản cao cấp của ứng dụng',
    removeAds: 'Mua phiên bản cao cấp',
    removeAdsDetail: 'Bạn chỉ cần thanh toán 1 lần, những lần sau sẽ tự khôi phục',
    paymentRecovery: 'Khôi phục thanh toán',
    paymentRecoveryDetail: 'Khôi phục thanh toán của bạn để nâng cấp phiên bản cao cấp',
    purchaseFailed: 'Thanh toán không thành công. Vui lòng thử lại.',
    purchaseSuccess: 'Thanh toán thành công, Cảm ơn bạn!',
    recoveryPaymentSuccess: 'Khôi phục thanh toán thành công!',
    recoveryPaymentUnsuccess: 'Khôi phục thanh toán không thành công. Xin vui lòng thử lại!',
    recoveryIfNeed: 'Nếu bạn đã thanh toán trước đó thì xin vui lòng chọn khôi phục thanh toán của bạn.',
    cancelIfNeed: 'Để hủy tự động gia hạn. Bạn vui lòng vào %s để thao tác',
    cancelSubsiOS: `Hủy gia hạn tự động trên iphone bạn thực hiện bước như sau ạ.
    - Mở ứng dụng Cài đặt trên iPhone.
    - Chạm vào tên bạn.
    - Chạm vào Đăng ký.
    - iPhone hiển thị tùy chọn menu Đăng ký trong phần Cài đặt.
    - Chạm vào đăng ký mà bạn muốn quản lý
    - Chạm vào Hủy đăng ký `,
    cancelSubsAndroid: `Huỷ gói trên điện thoại android bạn làm các bước sau
    - Vào Ứng dụng CH Play  trên điện thoại Android> Sau đó nhấn vào biểu tượng Tên tài khoản Google
    - Chọn Thanh toán và Gói thuê bao
    - Chọn Gói đăng ký
    - Chọn Gói Quý khách muốn Hủy
    - chọn Hủy
    - Chọn Để sau
    - Chọn Lý do Quý khách muốn hủy gói
    - Chọn Hủy gói thuê bao`,
    canSubs: 'Huỷ gia hạn',
    expireDate: 'Hạn sử dụng',
    expired: 'đã quá hạn',
    yourPackage: 'Bạn đang sử dụng phiên bản cao cấp',
    packageFull: 'Gói trọn đời không giới hạn',
    trial: 'Dùng thử 7 ngày',
    trialDetail: 'Sử dụng phiên bản cao cấp trong 7 ngày.\nHết thời gian sẽ về phiên bản miễn phí',
    package1M: 'Gói 1 tháng',
    package3M: 'Gói 3 tháng',
    package6M: 'Gói 6 tháng',
    package1Y: 'Gói 1 năm',
    package5Y: 'Gói 5 năm',
    package10Y: 'Gói 10 năm',
    package1MDetail: 'Sử dụng phiên bản cao cấp trong 1 tháng.\nHết thời gian sẽ tự động gia hạn',
    package3MDetail: 'Sử dụng phiên bản cao cấp trong 3 tháng.\nHết thời gian sẽ tự động gia hạn',
    package6MDetail: 'Sử dụng phiên bản cao cấp trong 6 tháng.\nGói được cộng dồn thời gian, và không tự động gia hạn',
    package1YDetail: 'Sử dụng phiên bản cao cấp trong 1 năm.\nGói được cộng dồn thời gian, và không tự động gia hạn',
    package5YDetail: 'Sử dụng phiên bản cao cấp trong 5 năm.\nGói được cộng dồn thời gian, và không tự động gia hạn',
    package10YDetail: 'Sử dụng phiên bản cao cấp trong 10 năm.\nKhông tự gia hạn',
    packageWarehouse1Y: 'Kho mở rộng 1 năm',
    packageWarehouse1YDetail: 'Thêm một kho mở rộng khác thời hạn 1 năm.\nKhông tự gia hạn',
    packageStaff1Y: 'Nhân viên 1 năm',
    packageStaff1YDetail: 'Gia hạn sử dụng tài khoản nhân viên trong 1 năm.\nKhông tự gia hạn',
    serviceFee: 'Phí dịch vụ',
    serviceFeeDetail: 'Sử dụng gói dịch vụ cao cấp để dùng đầy đủ chức năng của ứng dụng. Bấm chi tiết để xem thông tin.',
    packageAutoRenew: 'Gói tự động gia hạn',
    packageNonAutoRenew: 'Gói không tự động gia hạn',
    notFoundPurchase: 'Không tìm thấy thanh toán của bạn',
    purchaseLinkedWithOtherAcc: 'Thanh toán này đã liên kết với một tài khoản khác',
    recoverySumary: 'Nếu bạn đã thanh toán thành công nhưng chưa được kích hoạt gói cao cấp. Vui lòng chọn "Khôi phục thanh toán"',
    recoverySumary1: 'Nếu không thành công hãy thử thoát app vào lại.',
    purchaseProcessing: 'Thanh toán vẫn đang xử lý, vui lòng đợi trong giây lát. Nếu thanh toán thành công mà vẫn chưa đc cập nhật thì bạn hãy bấm khôi phục thanh toán nha.',
    iapInLoading: 'Chưa sẵn sàng. Vui lòng đợi trong giây lát',
    yourPackageInfo: 'Gói của bạn',
    compare: 'So sánh MIỄN PHÍ - CAO CẤP',
    trialConfirm: 'Bạn có chắc chắn muốn kích hoạt dùng thử gói CAO CẤP trong 7 ngày không? Khi hết hạn gói của bạn sẽ trở về gói MIỄN PHÍ',
    trialActive: 'Kích hoạt dùng thử',
    trialActiveDetail: 'Bạn đang sử dụng phiên bản miễn phí. Bạn có muốn kích hoạt dùng thử phiên bản cao cấp trong 7 ngày? Hết thời gian sẽ trở về phiên bản miễn phí!',
    autoRenewWarning: 'Huỷ gói gia hạn',
    autoRenewWarningDetail: 'Bạn đang sử dụng gói tự động gia hạn hàng tháng. Vui lòng huỷ gói này trước khi mua gói cao hơn để không bị trừ tiền hàng tháng!'
  },
  upgrade: {
    hasNewVersion: 'Có bản cập nhật mới',
    changelog: 'Thay đổi ở phiên bản mới',
    upgradeNow: 'Cập nhật',
    later: 'Để sau',
    changeLogs: [
      'Sửa lỗi chữ mờ khi chọn giao diện tối',
      'Sửa lỗi không lưu được đơn nhập hàng trên một số thiết bị',
      'Tối ưu quảng cáo phù hợp với giao diện sáng tối',
      'Thêm chức năng gửi file báo cáo lỗi đến nhà phát triển',
      'Và sửa một số lỗi nhỏ khác'
    ]
  },
  profile: {
    title: 'Cá nhân',
    nameShop: 'Tên shop',
    email: 'Email',
    address: 'Địa chỉ',
    phone: 'Số điện thoại',
    numberPhone: 'SĐT',
    edit: 'Chỉnh sửa',
    save: 'Lưu',
    bank: 'STK',
    billInfo: 'Thông tin cửa hàng',
    placholderBillInfo: 'Thông tin này sẽ hiển thị trên hóa đơn (SĐT, Địa chỉ, Ngân hàng...)',
    placholderBank: 'Nhập tài khoản ngân hàng',
    placholderName: 'Nhập tên shop',
    profileDetail: 'Cập nhật thông tin định danh và liên hệ của cửa hàng.',
    changeAvatar: 'Đổi ảnh đại diện',
    emailVerified: 'Email đã được xác thực, không thể thay đổi.',
    placholderEmail: 'Email không thể thay đổi',
    placholderAdress: 'Nhập địa chỉ',
    placholderPhone: 'Nhập số điện thoại',
    avatarEmpty: 'Mời bạn chọn ảnh',
    nameEmpty: 'Tên shop không được để trống',
    emailEmpty: 'Email không được để trống',
    adressEmpty: 'Địa chỉ không được để trống',
    phoneEmpty: 'Số điện thoại không được để trống',
    freeAcc: 'Miễn phí',
    proAcc: 'Cao cấp'
  },
  invoice: {
    stt: 'STT',
    titleImport: 'ĐƠN NHẬP HÀNG',
    title: 'ĐƠN BÁN HÀNG',
    titleReturn: 'ĐƠN TRẢ HÀNG',
    code: 'Mã số:',
    nameClient: 'Khách hàng',
    order: 'Mã hàng hóa',
    nameProduct: 'Tên hàng hóa',
    number: 'SL',
    totalPrice: 'Thành tiền',
    price: 'Tổng tiền',
    money: 'Đơn giá',
    buyer: 'Người mua hàng',
    salesman: 'Người bán hàng',
    writeFull: '(Ký, ghi rõ họ tên)',
    day: 'Ngày',
    month: 'tháng',
    year: 'năm',
    save: 'Lưu',
    unit: 'Đvt',
    thanks: 'Cảm ơn quý khách!',
    draft: 'HOÁ ĐƠN TẠM TÍNH'
  },
  barcode: {
    title: 'Barcode',
    message: 'Di chuyển camera đến vùng chứa để quét'
  },
  help: {
    removeAds: 'Tôi có thể bỏ quảng cáo không?',
    removeAdsDetail: 'Bạn có thể gỡ bỏ quảng cáo bằng cách mua gói phiên bản cao cấp. Bạn hoàn toàn có thể sử dụng hầu hết chức năng của ứng dụng mà không cần mua gói.',
    adsNotDisable: 'Tôi đã mua phiên bản cao cấp của nhưng quảng cáo vẫn xuất hiện',
    adsNotDisableDetail:
      '- Bạn vào mục "Biểu tượng menu góc trên bên trái" -> "Phiên bản cao cấp" -> Chọn "Khôi phục thanh toán". Khi một thông báo màu xanh xuất hiện thì tức là bạn đã khôi phục thanh toán thành công. Quảng cáo sẽ không xuất hiện nữa. \n- Nếu một thông báo màu đỏ xuất hiện tức là việc khôi phục thanh toán chưa thành công. Bạn Vui lòng kiểm tra lại thanh toán của bạn. Hoặc tài khoản iTune Store có cùng tài khoản thanh toán ko. \n- Trường hợp bạn đã thanh toán thành công nhưng không thể kích hoạt khôi phục thanh toán. Mời bạn liên hệ với nhà phát triển qua email: xgitdev@gmail.com để được hỗ trợ',
    recoveryData: 'Tôi có thể sao lưu hoặc chuyển dữ liệu của mình sang máy khác không?',
    recoveryDataeDetail:
      'Bạn có thể đăng ký một tài khoản, sau đó mở Menu chọn đồng bộ dữ liệu hiện tại lên, sau đó bạn sử dụng sẽ không bị mất dữ liệu nữa. Trường hợp thiết bị của bạn chưa có bất kỳ dữ liệu gì, ban có thể bỏ qua bước đồng bộ.\nSang thiết bị khác, bạn chỉ cần đăng nhập tài khoản hiện tại vào là có thể sử dụng bình thuờng.',
    recoveryDataAuto: 'Có thể tự động sao lưu dữ liệu không?',
    recoveryDataeAutoDetail: 'Từ phiên bản 4.0. Bạn không cần phải sao lưu dữ liệu bằng tay'
  },
  importFromCSV: {
    textHint: 'Nhập dữ liệu dạng text từ file CSV của bạn vào đây',
    title: 'Nhập nhanh từ file csv',
    choiceFile: 'Chọn file',
    intro: 'Bạn hãy nhập nội dung bên dưới để tạo đơn hàng hàng loạt. Bạn có thể xem mẫu và hướng dẫn tại',
    enterText: 'Nhập văn bản',
    newCustomer: 'Khách mới',
    productInvalid: 'Hàng hóa không hợp lệ',
    productInvalidMessage: 'Mã hàng hóa không hợp lệ. Vui lòng kiểm tra lại mã của hàng hóa được bôi đỏ',
    check: 'Kiểm tra',
    save: 'Lưu đơn hàng',
    emptyDataMessage: 'Chưa tìm thấy đơn hàng nào',
    complete: 'Đã nhập xong',
    gotIt: 'Tôi đã hiểu',
    here: 'tại đây',
    syntaxIntro1: 'Bạn có thể xem file mẫu file CSV mẫu ở đây.',
    syntaxIntro2: 'Sau đó bạn cần mở file CSV của bạn dưới dạng text, sau đó sao chép nội dung file CSV và dán vào ô nhập dữ liệu trong ô nhập liệu.',
    syntax: 'Cú pháp',
    examp: 'Ví dụ',
    syntaxTut: 'Bạn hãy định dạng dữ liệu theo cú pháp dưới đây. Các đơn hàng cách nhau bởi dấu xuống dòng.',
    syntaxDetail:
      'Số điện thoại|Tên khách hàng|Địa chỉ,Phụ phí,Mã hàng hóa|Số lượng|Giảm giá\nSố điện thoại|Tên khách hàng|Địa chỉ,Phụ phí,Mã hàng hóa|Số lượng|Giảm giá,Mã hàng hóa|Số lượng|Giảm giá\nSố điện thoại|Tên khách hàng|Địa chỉ,Phụ phí,Mã hàng hóa|Số lượng|Giảm giá,Mã hàng hóa|Số lượng|Giảm giá,Mã hàng hóa|Số lượng|Giảm giá,Mã hàng hóa|Số lượng|Giảm giá',
    syntaxExamp: '0123456789|NGUYEN VAN A|Ha Noi,10,SP1|5|0\n0123456789|NGUYEN VAN A|Ha Noi,10,SP1|5|0,SP2|4|0\n0123456789|NGUYEN VAN A|Ha Noi,10,SP1|5|0,SP2|4|0,SP3|4|0'
  },
  bill: {
    name: 'Bill',
    title: 'Hoá đơn thanh toán',
    product: 'Hàng',
    day: 'Ngày bán',
    amount: 'SL',
    money: 'T.Tiền',
    totalMoney: 'Tổng tiền',
    thanks: 'Cảm ơn quý khách!',
    createBy: 'Bán hàng chuyên nghiệp với ứng dụng',
    unit: 'Đvt',
    discount2: 'Giảm giá %',
    discount1: 'Giảm giá tiền',
    customImage: 'Ảnh tùy chỉnh',
    customText: 'Tuỳ chỉnh',
    moneyText: 'Số tiền bằng chữ'
  },
  printer: {
    connected: 'Máy in đã kết nối thành công!',
    name: 'Máy in',
    title: 'Kết nối máy in',
    find: 'Đang tìm máy in bluetooth. Vui lòng đợi một chút nhé!',
    empty: 'Không tìm thấy máy in nào',
    unknow: 'Không rõ',
    pressToConnect: 'Chạm để kết nối đúng thiết bị máy in của bạn',
    notConnect: 'Xin vui lòng kết nối máy in trong cài đặt.',
    trial: 'Còn %s lần dùng thử',
    trialExpired: 'Bạn đã sử dụng hết số lần dùng thử. Xin vui lòng nâng cấp phiên bản cao cấp để sử dụng tính năng này',
    printError: 'Máy in chưa sẵn sàng. Xin vui lòng thử lại!',
    devicesTested: 'Thiết bị đã đội phát triển đã test: xPrinter 58iiH, GOOJPRT PT-210',
    choice: 'Chọn máy in',
    require: 'Hỗ trợ máy in bill nhiệt có kết nối USB. Máy tính phải cài driver của máy in trước mới có thể kết nối',
    fixOnWindow: 'Fix lỗi không kết nối được trên Windows',
    printerDriverType: 'Loại driver kết nối',
    printerDriverTypeDetail: 'Chọn loại driver của máy in mà bạn đã cài đặt trên máy tính của bạn.',
    printerDriverTypeList: ['Driver của máy in (driver của hãng)', 'Driver Zadig (hướng dẫn của aSeller)'],
    printerSizeDetail: 'Chọn kích thước giấy in của bạn. Hỗ trợ khổ giấy A4, A5, 80mm, 58mm',
    choiceDriverTypeWarning: 'Vui lòng chọn loại driver đã cài đặt.'
  },
  importFromExcel: {
    textHint: 'Nhập dữ liệu dạng text từ file Excel của bạn vào đây',
    title: 'Nhập nhanh từ file Excel',
    choiceFile: 'Chọn file',
    intro: 'Bạn hãy nhập nội dung bên dưới để tạo đơn hàng hàng loạt. Bạn có thể xem mẫu và hướng dẫn tại',
    introProduct:
      'Hãy chọn file excel để nhập nhanh hàng hóa. Vui lòng không chọn file mà bạn đã xuất từ danh sách hàng hóa vì định dạng file ko giống nhau. Bạn có thể xem mẫu và hướng dẫn tại',
    introProduct1: 'Bạn nên sử dụng phiên bản web để dễ thao tác hơn. Đơn vị và danh mục bạn phải nhập trước hệ thống mới nhận dạng được',
    enterText: 'Nhập văn bản',
    newCustomer: 'Khách mới',
    productInvalid: 'Hàng hóa không hợp lệ',
    productInvalidMessage: 'Mã hàng hóa không hợp lệ. Vui lòng kiểm tra lại mã của hàng hóa được bôi đỏ',
    check: 'Kiểm tra',
    save: 'Lưu %s mặt hàng',
    emptyDataMessage: 'Chưa tìm thấy đơn hàng nào',
    complete: 'Đã nhập xong',
    gotIt: 'Tôi đã hiểu',
    here: 'tại đây',
    found: 'Tìm thấy %s mặt hàng',
    demo: 'File mẫu',
    syntaxIntro1:
      'Mỗi lần bạn nên nhập dưới 500 bản ghi. Bạn có thể tách thành nhiều file để nhập. Hàng hoá không được trùng tên, mã code, mã SKU. Cột nào không cần thay đổi thì bạn nên xoá đi. Bạn có thể tham khảo file mẫu ở đây.',
    syntaxIntro2: 'Sau đó bạn cần mở file Excel của bạn dưới dạng text, sau đó sao chép nội dung file Excel và dán vào ô nhập dữ liệu trong ô nhập liệu.'
  },
  unit: {
    id: 'Mã đơn vị',
    title: 'Đơn vị tính',
    choice: 'Lựa chọn đơn vị',
    create: 'Tạo đơn vị mới',
    name: 'Tên đơn vị',
    search: 'Lọc theo mã, tên đơn vị',
    exist: 'Tên đơn vị đã tồn tại',
    convert: 'Đơn vị quy đổi',
    addConvert: 'Thêm đơn vị quy đổi',
    editConvert: 'Sửa đơn vị quy đổi',
    valueConvert: 'Giá trị quy đổi',
    invalidValueConvert: 'Thông tin đơn vị quy đổi chưa hợp lệ. Vui lòng kiểm tra lại!',
    invalidMainUnit: 'Vui lòng chọn đơn vị chính trước khi tạo đơn vị quy đổi!',
    sameMainUnit: 'Đơn vị quy đổi không thể giống đơn vị chính. Vui lòng chọn sang đơn vị khác!',
    deleteUnitConvert: 'Xoá đơn vị quy đổi',
    deleteUnitConvertWarning: 'Bạn có chắc chắn muốn xoá đơn vị quy đổi này không? Những đơn vị quy dổi đã được sử dụng trong đơn hàng sẽ không thể xóa.',
    choiceMainUnitFirstWarning: 'Vui lòng chọn đơn vị tính cho sản phẩm trước khi tạo đơn vị quy đổi.',
    tips: 'Gợi ý',
    tip1: 'Sử dụng đơn vị tính chuẩn (Ví dụ: Cái, Gói, Hộp, Thùng...).',
    tip2: 'Đơn vị tính giúp quản lý kho và bán hàng chính xác hơn.',
    tip3: 'Bạn có thể thiết lập quy đổi đơn vị ngay trong phần chi tiết sản phẩm.'
  },
  timeFilter: {
    today: 'Hôm nay',
    yesterday: 'Hôm qua',
    last7Days: '7 ngày gần đây',
    last30Days: '30 ngày gần đây',
    thisMonth: 'Tháng này',
    lastMonth: 'Tháng trước',
    custom: 'Tùy chỉnh',
    choiceMonth: 'Chọn tháng',
    choiceStartDate: 'Bắt đầu',
    choiceEndDate: 'Kết thúc'
  },
  autoRestoreDb: {
    title: 'Khôi phục dữ liệu',
    message: 'Chúng tôi đã phát hiện một phiên bản dữ liệu mới hơn của tài khoản của bạn. Bạn có muốn đồng bộ với dữ liệu mới nhất đó ko?'
  },
  support: {
    title: 'Hỗ trợ trực tiếp',
    emailSupportDetail: 'Bạn muốn liên hệ với chúng tôi. Vui lòng chọn một trong những phương thức liên hệ sau đây.',
    emailSupport: 'Gửi email cho nhà phát triển',
    zaloSupportDetail: 'Nếu bạn cần hỗ trợ khẩn cấp như lỗi ứng dụng, hoặc hỏi đáp cách sử dụng. Xin vui chọn hỗ trợ qua Zalo',
    zaloSupport: 'Hỗ trợ qua nhóm zalo'
  },
  customerDebt: {
    title: 'Tổng công nợ',
    total: 'Tổng còn nợ',
    customerDebtStatistial: 'Công nợ theo khách hàng',
    beginningBalance: 'Số dư đầu kỳ',
    beginningDebts: 'Nợ đầu kỳ',
    closingBalance: 'Số dư cuối kỳ',
    closingDebts: 'Nợ cuối kỳ',
    showAll: 'Hiển thị tất cả dòng tiền',
    simple: 'Phiên bản rút gọn',
    hideProduct: 'Ẩn hàng hoá',
    timeRange: 'KHOẢNG THỜI GIAN',
    displayConfig: 'CẤU HÌNH HIỂN THỊ',
    debtCheckWarning: '(Vui lòng kiểm tra lại và đối soát thông tin trên)',
    scanToPay: 'QUÉT MÃ THANH TOÁN',
    scanToPayHint: 'Dùng ứng dụng Ngân hàng hoặc Ví điện tử để quét mã'
  },
  returnOrder: {
    edit: 'Sửa đơn trả hàng',
    create: 'Thêm đơn trả hàng'
  },
  maintenance: {
    title: 'Bảo trì',
    message: 'Máy chủ của chúng mình đang tiến hành bao trì trong khoảng %s phút. Bạn vui lòng thử lại sau nha!!!',
    timeout: 'Rất tiếc đã có lỗi xảy ra. Bạn vui lòng thử lại sau một vài phút. Nếu vẫn không được, hãy liên hệ team mình hỗ trợ nha!!!',
    messageTimeout:
      'Máy chủ của chúng mình đang bận chút xíu! Bạn hãy thử tải lại nha! Nếu vẫn không tải được bạn hãy nghỉ ngơi khoảng 1-5 phút sau rồi thử lại!. Cảm ơn bạn rất nhiều!',
    networkError: 'Lỗi mạng',
    networkErrorDetail:
      'Lỗi đường truyền internet. Bạn hãy thử kiểm tra lại WIFI hoặc 4G của bạn. Nếu vẫn không tải được, hãy liên hệ chúng mình trợ giúp nha! Cảm ơn bạn rất nhiều!'
  },
  financialBook: {
    title: 'Dòng tiền',
    receipts: 'Phiếu thu',
    paymentVoucher: 'Phiếu chi',
    debt: 'Phiếu nợ',
    createDebt: 'Tạo phiếu nợ',
    moneyFromCustomer: 'Tiền thu của khách',
    moneyForProvider: 'Tiền chi cho nhà cung cấp',
    moneyForReturn: 'Tiền trả lại cho đơn hoàn',
    moneyFromReturn: 'Tiền nhận lại từ đơn hoàn',
    idAutoGen: 'Mã phiếu tự động',
    cash: 'Tiền mặt',
    bank: 'Ngân hàng',
    totalFund: 'Tổng quỹ',
    submitter: 'Người tạo',
    typeCharge1: 'Loại thu',
    typeCharge2: 'Loại chi',
    receipt: 'Tạo phiếu thu',
    vouchers: 'Tạo phiếu chi',
    fullName: 'Họ tên',
    submitters: 'Người nộp',
    money: 'Số tiền',
    textEmptyFinancial: 'Bạn chưa có phiếu thu/chi nào.',
    accountBank: 'Tài khoản nhận',
    nameBank: 'Tài khoản ngân hàng',
    accountNumber: 'Số tài khoản',
    accountHolder: 'Chủ tài khoản',
    receiptForOrder: 'Phiếu thu cho đơn hàng',
    paymentForOrder: 'Phiếu chi cho đơn hàng',
    receiptFromCustomer: 'Phiếu thu từ khách hàng',
    receiptAutoGenFor: 'Phiếu thu tự động tạo cho đơn hàng',
    paymentForProvider: 'Phiếu chi cho nhà cung cấp',
    paymentForCustomer: 'Phiếu chi cho khách hàng',
    paymentVoucherAutoGenFor: 'Phiếu chi tự động tạo cho đơn hàng',
    autoFinancialCanNotEdit: 'Phiếu này được tạo tự động. Vui lòng sửa đơn hàng liên quan',
    createType: 'Tạo mới',
    deleteType: 'Xóa phân loại',
    deleteTypeWarning: 'Bạn có chắc chắn muốn xóa phân loại %s không?',
    exportBill: 'Xuất phiếu',
    deleteBill: 'Xóa phiếu',
    deleteBillWarning: 'Bạn có chắc chắn muốn xóa phiếu này không?',
    investment: 'Quỹ đầu vào',
    investmentDetail:
      'Quỹ đầu vào là sô tổng số dư (Doanh thu - chi tiêu) tính từ thời điểm ban đầu bán đến thời điểm đầu kỳ. \nVD: Thời gian bạn chọn là tháng này, thì quỹ đầu vào nó là số dư từ trước ngày 01 đầu tháng trở về trước',
    totalRevenue: 'Tổng doanh thu',
    totalSpending: 'Tổng chi tiêu',
    totalBlance: 'Tổng số dư'
  },
  sortType: {
    newest: 'Mới nhất',
    oldest: 'Cũ nhất',
    alphabet: 'Chữ cái'
  },
  guide: {
    revenue: 'Tổng thu',
    expenditure: 'Tổng chi',
    title: 'Gợi ý cho người mới bắt đầu',
    expenseReport: 'Sổ quỹ tài chính',
    product: 'Để bắt đầu, Thêm hàng hóa hoặc dịch vụ bạn cung cấp.',
    customer: 'Thêm mới khách hàng là thao tác cơ bản để bạn khởi tạo các thông tin của khách hàng và quản lý công nợ trong quá trình giao dịch sau này.',
    provider: 'Bạn cần tạo nhà cung cấp để có thể quản lý được mọi dữ liệu liên quan đến Nhà cung cấp: Thông tin liên hệ, công nợ, lịch sử nhập hàng…',
    order: 'Đơn hàng sẽ được ghi nhận xuất kho, giao hàng cho khách ngay khi tạo thành ...',
    category: 'Danh mục là nơi để bạn quản lý tập hợp các danh mục mặt hàng.',
    complete: 'Bạn đã thành thạo các thao tác cơ bản. Còn nhiều tính năng nữa aSeler đã thiết kế cho riêng bạn, tiếp tục khám phá nhé !!'
  },
  productHistoryLog: {
    title: 'Lịch sử kho',
    sale: 'Xuất kho',
    import: 'Nhập kho',
    update: 'Kiểm kho',
    return: 'Hoàn lại kho',
    delete: 'Hoàn đơn hủy',
    amount: 'Số lượng giao dịch',
    result: 'Số lượng sau giao dịch',
    importReturn: 'Hoàn lại nhà cung cấp'
  },
  orderType: {
    sale: 'Bán hàng',
    return: 'Trả hàng',
    importReturn: 'Trả hàng nhập',
    import: 'Nhập hàng',
    receipt: 'Phiếu thu',
    payment: 'Phiếu chi',
    debt: 'Phiếu nợ'
  },
  newCodepush: {
    title: 'Phiên bản vá lỗi mới',
    des: 'Có phiên bản vá lỗi mới được phát hành. Bạn có muốn cập nhật ngay để sử dụng ổn định hơn không?',
    cancel: 'Để sau',
    ok: 'Cập nhật'
  },
  printSetting: {
    tearOffset: 'Khoảng cách từ dao cắt đến đầu in (mm)',
    tearOffsetDetail: 'Khoảng này sẽ dùng để nhả giấy ra đủ để cắt mà không bị mất nội dung đã in',
    title: 'Cài đặt máy in',
    type: 'Loại máy in',
    typeDetail: 'Máy in chỉ in được hoá đơn hãy chọn máy in ESC/POS. Máy in có thể in cả tem nhãn và in hoá đơn hãy chọn ZPL, TSPL.',
    connection: 'Máy in',
    size: 'Kích thước khổ in',
    qrBank: 'Thêm ảnh tuỳ chỉnh cuối hoá đơn',
    qrBankDetail: 'Bạn có thể thêm mã QR ngân hàng, logo cửa hàng, hiển thị dưới cuối hoá đơn.',
    asellerLogo: 'Hiển thị aSeller logo',
    bluetooth: 'Máy in bluetooth',
    wifi: 'Máy in WIFI',
    deviceIp: 'Địa chỉ IP máy in',
    deviceIpEx: 'VD: 192.168.1.100',
    invalidIP: 'Vui lòng nhập IP hợp lệ!',
    canNotConnectIP: 'Không thể kết nối đến IP này. Vui lòng kiểm tra lại IP của máy in!',
    notReady: 'Máy in chưa sẵn sàng. Vui lòng vào cài đặt máy in trước!',
    support:
      'Hỗ trợ máy in nhiệt ESC/POS kết nối WIFI, Bluetooth, USB.\nLưu ý: Chức năng in bill không hỗ trợ máy in tem nhãn.\nBạn có thể tham khảo những máy in hỗ trợ ở mục "Thiết bị bán hàng" ở ngoài trang chủ.',
    orientation: 'Chiều khổ in',
    potrait: 'Chiều dọc',
    landscape: 'Chiều ngang',
    method: 'Ngôn ngữ hỗ trợ',
    esc: 'ESC/POS, ESC...',
    escDetail: 'Là máy in chuyên dụng để in hoá đơn',
    tsc: 'ZPL, EPL, TSPL...',
    tscDetail: 'Máy in có thể in cả hoá đơn, tem dán, mã vạch...',
    threshold: 'Độ đậm của chữ',
    thresholdTypeList: ['Vừa', 'Đậm', 'Rất đậm'],
    speed: 'Tốc độ in',
    speedTypeList: ['Tự động', 'Chậm'],
    spacingBottom: 'Khoảng trắng bên dưới'
  },
  homeOfflineWarning: {
    message: 'Bạn đang sử dụng OFFLINE. Hãy chuyển sang ONLINE để sử dụng nhiều tính năng hơn. Và không bị mất dữ liệu.',
    helpButton: 'Huớng dẫn chuyển sang online'
  },
  statStock: {
    typeChoice: 'Thống kê kho theo',
    inventoryCapital: 'Vốn tồn'
  },
  customerGroup: {
    title: 'Nhóm khách hàng',
    search: 'Lọc theo tên, hoặc mã',
    id: 'Mã nhóm',
    prefix: 'Tiền tố mã nhóm',
    create: 'Thêm nhóm',
    choice: 'Chọn nhóm khách',
    choiceCustomers: 'Thêm khách hàng vào trong nhóm',
    name: 'Tên nhóm',
    tablePrice: 'Bảng giá',
    priceHint: 'Bảng giá sẽ tự động được áp dụng trong đơn bán hàng khi khách hàng thuộc nhóm này',
    editNotice: 'Đang ở chế độ chỉnh sửa - Nhấn "Lưu" ở góc trên để hoàn tất',
    removeCustomer: 'Bạn có chắc chắn muốn xoá khách hàng này khỏi nhóm?'
  },
  settings: {
    title: 'Cài đặt',
    garena: 'Cài đặt chung',
    home: 'Cài đặt trang chủ',
    order: 'Cài đặt đơn hàng',
    product: 'Cài đặt hàng hóa',
    invoice: 'Cài đặt hóa đơn',
    debt: 'Cài đặt dư nợ',
    point: 'Cài đặt tích điểm',
    salesGroup: 'Bán hàng & Hoá đơn',
    systemGroup: 'Hệ thống & Giao diện',
    businessGroup: 'Khách hàng & Doanh nghiệp',
    accountGroup: 'Tài khoản & Bảo mật',
    displayAndTheme: 'Giao diện & Hiển thị',
    currencyAndTime: 'Tiền tệ & Thời gian',
    security: 'Bảo mật',
    stockSettings: 'Thiết lập kho hàng',
    homeWidgets: 'Tiện ích trang chủ',
    pointSettings: 'Cấu hình tích điểm',
    resetPointTitle: 'Cài đặt lại',
    systemPermissions: 'Quyền hệ thống',
    invoiceSettings: 'Cài đặt hoá đơn',
    debtSettings: 'Công nợ',
    orderSettings: 'Thiết lập đơn hàng',
    descOrder: 'Trạng thái, làm tròn, phí phụ thu, dịch vụ',
    descProduct: 'Tồn kho, giá vốn, định mức ban đầu',
    descInvoice: 'Mẫu hoá đơn, mã VietQR, tài khoản ngân hàng',
    descPrinter: 'Khổ giấy in, máy in Bluetooth, Wifi, USB',
    descShift: 'Quản lý mở ca, kết ca, bàn giao tiền',
    descGeneral: 'Giao diện, ngôn ngữ, cỡ chữ, tiền tệ, mã PIN',
    descHome: 'Hiển thị doanh thu, biểu đồ, báo cáo tài chính',
    descPermission: 'Máy ảnh, thư viện ảnh, Bluetooth, thông báo',
    descPoint: 'Tích điểm thành viên, tỷ lệ quy đổi điểm',
    descShop: 'Quản lý chi nhánh, nhân viên, website bán hàng',
    descEInvoice: 'Cấu hình và phát hành hoá đơn điện tử',
    descPassword: 'Cập nhật mật khẩu bảo vệ tài khoản',
    descDeleteAcc: 'Xoá vĩnh viễn tài khoản và dữ liệu cửa hàng',
    shopManager: 'Quản lý cửa hàng',
    staffRole: 'Nhân viên',
    granted: 'Đã cấp',
    grantPermission: 'Cấp quyền',
    noVietQRConfig: 'Chưa cấu hình tài khoản VietQR',
    uploadQRImage: 'Tải lên ảnh mã QR',
    s2aHkdGroup: 'Nhóm ngành nghề S2A-HKD',
    s2aHkdGroupDetail: 'Nhóm ngành nghề mặc định khi xuất sổ S2A-HKD',
    s2aHkdTaxRate: 'Tỷ lệ thuế mặc định S2A-HKD (%)',
    s2aHkdTaxRateDetail: 'Dùng khi sản phẩm/đơn không có VAT rõ ràng',
    s2aHkdTncnRate: 'Tỷ lệ thuế TNCN S2A-HKD (%)',
    s2aHkdTncnRateDetail: 'Tỷ lệ thuế thu nhập cá nhân (%) dùng khi xuất S2A-HKD',
    manualEnterIPDetail: 'Nhập trực tiếp IP máy in nếu không quét thấy',
    previewPrint: 'Xem trước mẫu in'
  },
  customerPoint: {
    pointShort: 'Điểm',
    point: 'Điểm tích lũy',
    description: 'Quản lý điểm thưởng khách hàng',
    history: 'Lịch sử tích lũy',
    use: 'Bật chức năng tích điểm',
    mtpRate: 'Tỷ lệ quy đổi điểm',
    mtpRateDetail: 'Giá trị đơn hàng %s%s = 1 điểm tích lũy',
    ptmRate: 'Tỷ lệ quy đổi sang tiền',
    ptmRateDetail: '1 điểm = %s%s',
    allowPayment: 'Cho phép thanh toán bằng điểm',
    allowForSaleProduct: 'Tích điểm cho hàng hóa giảm giá',
    allowForOrderPayByPoint: 'Tích điểm đơn hàng thanh toán bằng điểm thưởng',
    change: 'Cập nhật điểm tích lũy',
    invalidPoint: 'Số điểm không hợp lệ',
    invalidNote: 'Vui lòng nhập ghi chú',
    usePoint: 'Sử dụng điểm',
    showPointOnInvoice: 'Hiển thị điểm trên hóa đơn',
    reset: 'Xóa hết điểm tích lũy',
    resetWarning: 'Bạn có chắc chắn muốn xóa hết điểm tích lũy hiện tại của khách hàng không?'
  },
  shift: {
    title: 'Chốt ca',
    end: 'Chốt ca',
    totalOrder: 'Tổng hoá đơn',
    totalMoney: 'Tổng tiền ca',
    paid: 'Tổng tiền bàn giao',
    staff: 'Nhân viên',
    cash: 'Tiền mặt',
    bank: 'Chuyển khoản',
    emptyOrder: 'Chưa có đơn hàng phát sinh trong ca này.',
    shiftOrder: 'Đơn hàng của ca',
    open: 'Mở ca',
    closed: 'Đã đóng',
    opening: 'Đang mở',
    openingAmount: 'Tiền đầu ca',
    handoverType: 'Hình thức bàn giao',
    openingAmountDetail: 'Số tiền có sẵn khi bắt đầu ca',
    actualHandoverAmount: 'Tiền thực tế',
    differenceAmount: 'Chênh lệch',
    totalExpectedHandoverAmount: 'Tổng tiền cần bàn giao',
    orderUnit: 'đơn',
    currencyUnit: 'đ',
    endReport: 'BÁO CÁO KẾT CA',
    ended: 'Đã kết ca',
    shift: 'Ca bán hàng',
    shiftClosedDesc: 'Ca đã chốt và bàn giao',
    actualHandoverDesc: 'Số tiền thực tế nhân viên bàn giao',
    updatingOnClose: 'Sẽ cập nhật khi chốt ca',
    matchedDiffDesc: 'Số tiền hoàn toàn trùng khớp',
    checkDiffDesc: 'Cần kiểm tra đối soát lý do chênh lệch',
    diffCalculatedOnClose: 'Tính sau khi bàn giao ca',
    searchOrdersPlaceholder: 'Tìm theo mã đơn, khách hàng, số điện thoại...',
    handoverTypeDetail: 'Phương thức tiền thu được khi nhân viên chốt và bàn giao ca',
    requireOpening: 'Bắt buộc mở ca',
    requireOpeningDetail: 'Đơn bán hàng chỉ được tạo khi có ca đang mở',
    settings: 'Cài đặt ca',
    settingsDetail: 'Cấu hình mở và bàn giao ca',
    openError: 'Không thể mở ca',
    expectedHandoverAmount: 'Tiền cần bàn giao',
    totalMoneyInShift: 'Tổng tiền trong ca',
    needHandover: 'Cần bàn giao',
    endConfirm: 'Bạn có chắc chắn muốn chốt ca không?'
  },
  warehouse: {
    title: 'Kho hàng (chi nhánh)',
    renew: 'Gia hạn kho hàng',
    choice: 'Chọn kho hàng',
    intro: 'Các kho khác nhau sẽ có chỉ số tồn kho, doanh số, tài chính... khác nhau. Vào mục "Quản lý kho" để tạo kho mới.',
    stat: 'Tình trạng kho',
    createNew: 'Tạo phiếu',
    create: 'Tạo kho hàng',
    checkId: 'Mã kiểm kho',
    name: 'Tên kho hàng',
    check: 'Kiểm kho',
    createCheck: 'Tạo phiếu kiểm kho',
    history: 'Lịch sử kiểm kho',
    noHistory: 'Chưa có lịch sử kiểm kho. Vui lòng tạo phiếu mới',
    noTransferHistory: 'Chưa có lịch sử chuyển kho!',
    totalProduct: 'Tổng sản phẩm',
    tmpCheck: 'Phiếu tạm',
    cancelCheckConfirm: 'Bạn có chắc chắn muốn hủy phiếu kiểm này?',
    cancelTransferConfirm: 'Bạn có chắc chắn muốn hủy phiếu chuyển kho này?',
    default: 'Kho chính',
    address: 'Địa chỉ kho',
    manager: 'Quản lý kho (chi nhánh)',
    detail: 'Thông tin kho hàng',
    transfer: 'Chuyển kho',
    transferCard: 'Chi tiết chuyển kho',
    checkCard: 'Chi tiết kiểm kho',
    exportCheckCard: 'Phiếu kiểm kho',
    exportTransferCard: 'Phiếu chuyển kho',
    emptyTargetWarehouse: 'Kho đích không hợp lệ. Vui lòng chọn kho đích!',
    limit: 'Lưu ý: Mỗi tài khoản được miễn phí 1 tháng cho kho thứ 2. Sau khi hết hạn sẽ phải gia hạn thêm để sử dụng',
    expired: 'Kho này đã hết hạn. Vui lòng gia hạn thêm để sử dụng!',
    package1Y: 'Gia hạn 1 năm',
    importFromExcelHint: 'Nhập nhanh sản phẩm từ file excel.',
    importFromExcelEmptyChange: 'Không tìm thấy thay đổi nào.',
    stopActive: 'Ngừng kích hoạt',
    stopActiveWarning: 'Khi ngừng kích hoạt kho, kho sẽ bị ẩn khỏi danh sách chọn. Bạn có chắc chắn muốn bỏ kích hoạt kho này không?',
    emptyTransferHint: 'Chạm vào "Quét mã" hoặc "Sản phẩm" để bắt đầu chuyển kho',
    emptyCheckHint: 'Chạm vào "Quét mã" hoặc "Sản phẩm" để bắt đầu kiểm kho',
    noProduct: 'Chưa chọn sản phẩm'
  },
  homeScreen: {
    support: 'Bạn cần hỗ trợ?',
    supportDetail: 'Vui lòng chọn một hình thức liên hệ hỗ trợ dưới đây để chúng tôi có thể hỗ trợ bạn.',
    hotlineSupportDetail: 'Hotline chỉ hỗ trợ giờ hành chính, từ 09:00 - 17:00.',
    changelog: 'Nhật ký thay đổi',
    changelogDetail: 'Theo dõi nhật ký thay đổi thay đổi, những tính năng mới nhất của ứng dụng. ',
    autoUpdate: 'Cập nhật bản vá',
    autoUpdateDetail: 'Hệ thống sẽ cập nhật bản vá mới nhất để sửa một số lỗi nhỏ mà không cần cài đặt phiên bản mới nhất trên cửa hàng ứng dụng.',
    autoUpdateNoAvailable: 'Bạn đang dùng phiên bản mới nhất!',
    autoUpdateFailed: 'Đã có lỗi trong quá trình cập nhật. Vui lòng thử lại sau!',
    vipExpired: 'Gói cao cấp của bạn đã hết hạn. Vui lòng gia hạn thêm để sử dụng đầy đủ chức năng!',
    timeZoneNew: 'Cập nhật múi giờ',
    timeZoneConfirm: 'Bạn có chắc chắn muốn cập nhật báo cáo sang múi giờ mới. Bạn có thể cài đặt lại trong phần "Cài đặt chung"',
    timeZoneNewDetail:
      'Thiết bị của bạn đang sử múi giờ %s. Chúng tôi đã cập nhật báo cáo chính xác theo múi giờ hiện tại của bạn. Những báo cáo đã xuất trước đó có thể bị thay đổi. Để xem lại báo cáo cũ, xin hãy truy cập mục "Thống kê (cũ)"'
  },
  productSetting: {
    sort: 'Sắp xếp danh sách',
    sortDetail: 'Sắp xếp thứ tự sản phẩm theo',
    sortTypes: ['Mới nhất trước', 'Tên theo bảng chữ cái', 'Cũ nhất trước', 'Hạn sử dụng']
  },
  intro: {
    shift: 'Chức năng này dành cho loại hình kinh doanh dịch vụ. Nhân viên sử dụng app của nhân viên để chốt ca. Thông tin chốt ca của nhân viên sẽ được hiển thị ở đây.',
    customerGroup:
      'Tính năng này để nhóm các đối tượng khách hàng. VD đại lý cấp 1, đại lý cấp 2... Bạn có thể tạo bảng giá hàng hoá cho từng nhóm khách hàng. Khi tạo đơn hàng, khách hàng thuộc nhóm có bảng giá, thì bảng giá đó sẽ tự động được áp dụng!',
    emptyProduct: 'Chưa có hàng hóa nào. Vui lòng thêm hàng hóa để tiếp tục!',
    draftOrder:
      'Chức năng này phù hợp khi bạn muốn tạo nhiều đơn cùng một lúc. Và bạn có thể tạo đơn bán hàng ngay khi không có kết nối mạng. Điều này rất hữu ích trong trường hợp kết nối của bạn có vấn đề, hoặc máy chủ bị bảo trì.'
  },
  printBarcode: {
    print: 'In tem nhãn',
    list: 'Danh sách tem nhãn',
    config: 'Cấu hình tem nhãn',
    size: 'Kích thước 1 tem (Dài x Rộng) (mm)',
    note: 'Lưu ý',
    column: 'Số cột của khổ in',
    paddingH: 'Khoảng cách chiều\nngang giữa 2 tem (mm)',
    paddingV: 'Khoảng cách chiều\ndọc giữa 2 tem (mm)',
    noteDetail: 'Trong trường hợp mã vạch không quét được, hoặc bị mất một phần. Vui lòng sử dụng khổ giấy lớn hơn, hoặc rút ngắn mã vạch lại',
    dpi: 'Dpi của máy in',
    multiUpdateQuantity: 'Cập nhật số lượng hàng loạt',
    invalidQuantity: 'Số lượng không hợp lệ!',
    barcodeWidth: 'Chiều rộng của mã code',
    autoPrintWhenInBill: 'Tự động in nhãn khi in bill',
    autoPrintWhenInBillDetail: 'Khi kích hoạt chức năng này. Nhãn dán của sản phẩm sẽ được in tự động mỗi lần bạn bấm in hoá đơn.',
    printerNotRealdy: 'Máy in nhãn chưa sãn sàng. Vui lòng vào cài đặt in mã code để cập nhật!',
    contentToDisplay: 'Nội dung hiển thị trên tem',
    parameters: 'Thông số',
    lengthXWidth: 'Dài × Rộng (mm)',
    sampleProduct: 'Sản phẩm mẫu'
  },
  draftOrder: {
    title: 'Đơn nháp',
    manager: 'Quản lý đơn nháp',
    cancel: 'Hủy Nháp',
    cancelConfirm: 'Bạn có chắc chắn muốn hủy đơn nháp này không?',
    noConnectionWarning: 'Thiết bị của bạn đang không được kết nối mạng. Vào mục "Quản lý đơn nháp" dưới đây để tạo đơn nháp mà ko cần kết nối mạng.',
    emergencyModeWarning: 'Bạn đang ở chế độ khẩn cấp. Đơn hàng chỉ được lưu tạm trên thiết bị, chưa được ghi vào dữ liệu.',
    exportInvoice: 'Xuất HĐ Tạm Tính'
  },
  deleteAcc: {
    title: 'Xóa tài khoản',
    warning: 'Bạn có chắc chắn muốn xóa tài khoản này? Sau khi xóa, bạn sẽ không thể khôi phục dữ liệu. Bạn sẽ cần mã xác nhận từ gửi đến email của mình!',
    confirmCode: 'Mã xác nhận',
    confirmCodeShort: 'Mã xác nhận quá ngắn'
  },
  debtNotify: {
    name: 'Thông báo thu nợ',
    title: 'Nợ cần thu từ ',
    money: 'Số tiền cần thu: '
  },
  restartApp: {
    title: 'Khởi động lại ứng dụng',
    detail: 'Bạn có muốn khởi động lại ứng dụng để những thay đổi được cập nhật?'
  },
  appError: {
    eyebrow: 'Đã xảy ra sự cố',
    title: 'Ứng dụng cần được tải lại',
    detail: 'Một lỗi không mong muốn đã xảy ra. Vui lòng tải lại ứng dụng để tiếp tục.',
    reload: 'Tải lại ứng dụng'
  },
  shopSetting: {
    link: 'Đường dẫn website',
    publicSetting: 'Cài đặt website bán hàng',
    publicSettingHint: 'Khách hàng có thể đặt hàng trực tiếp thông qua link shop gửi cho khách. Bạn cần kích hoạt gói PLUS để sử dụng chức năng này.',
    userName: 'Tên định danh cửa hàng',
    userNameHint: 'Tên này sẽ hiển thị trên link gửi cho khách hàng. Không được chứa dấu cách hoặc ký tự đặc biệt (được phép chứa dấu gạch ngang và dấu gạch dưới).',
    staffRefLink: 'Link ref cho nhân viên',
    staffRefLinkHint: 'Link shop của nhân viên. Khách hàng click vào link này thì đơn hàng sẽ được tính cho nhân viên đó',
    customerCanRegister: 'Cho phép khách hàng đăng ký tài khoản',
    customerCanRegisterDetail: 'Khách hàng có thể tự đăng ký tài khoản. Nếu kích hoạt thì giá của sản phẩm sẽ hiển thị công khai cho tất cả các khách hàng.',
    retailPurchase: 'Cho phép khách lẻ mua hàng',
    retailPurchaseDetail: 'Khách hàng có thể tạo đơn hàng mà không cần tài khoản',
    theme: 'Giao diện',
    themeDetail: 'Lựa chọn giao diện trang web để hiển thị cho khách hàng',
    shopName: 'Tên cửa hàng',
    banner: 'Ảnh banner cửa hàng',
    bannerDetail: 'Ảnh banner cửa hàng kích thước đề xuất 1024x512px',
    color: 'Màu sắc',
    colorDetail: 'Chỉnh sửa màu sắc của giao diện website bán hàng',
    colorTextNormal: 'Màu chữ thường',
    colorTextActive: 'Màu chữ nổi',
    colorBackground: 'Màu nền',
    showPricePublic: 'Hiển thị giá',
    showPricePublicDetail: 'Hiển thị giá công khai cho tất cả khách truy cập',
    initWebsite: 'Khởi tạo website',
    moreSettingOnWeb: 'Vui lòng sử dụng phiên bản web để cấu hình website bán hàng đầy đủ hơn.',
    productList: 'Danh sách sản phẩm',
    productListDetail: 'Cài đặt danh sách sản phẩm hiển thị trên website bán hàng. Mặc định sẽ hiển thị tất cả sản phẩm',
    promotionList: 'Danh sách khuyến mại',
    promotionListDetail: 'Cài đặt danh sách khuyến mại hiển thị trên website bán hàng. Mặc định không hiển thị',
    domain: 'Tên miền riêng',
    domainDetail: 'Cấu hình tên miền riêng cho cửa hàng',
    domainDetailWidthIP: 'Để cấu hình tên miền riêng cho cửa hàng.\n Vui lòng tắt Cloudflare và trỏ IP tên miền về %s',
    requirePlus: 'Vui lòng kích hoạt gói PLUS trước khi thực hiện chức năng này!'
  },
  promotion: {
    edit: 'Sửa khuyến mại ',
    create: 'Tạo khuyến mại',
    choice: 'Chọn khuyến mại',
    title: 'Khuyến mại',
    manage: 'Quản lý khuyến mại',
    detail: 'Chi tiết khuyến mại',
    name: 'Tên khuyến mại',
    code: 'Mã khuyến mại',
    type: 'Loại khuyến mại',
    info: 'Thông tin khuyến mại',
    order: 'Giảm giá hoá đơn',
    product: 'Giảm giá sản phẩm',
    orderGift: 'Quà tặng hoá đơn',
    productGift: 'Quà tặng khi mua hàng',
    minMoney: 'Số tiền tối thiểu',
    minQuantity: 'Số lượng tối thiểu',
    value: 'Giá trị khuyến mại',
    price: 'Giá khuyến mại',
    discountPercent: 'Giảm theo %',
    time: 'Thời gian khuyến mại',
    choiceGift: 'Chọn quà tặng',
    gift: 'Quà tặng',
    originalPrice: 'Giá gốc',
    delete: 'Xoá khuyến mại',
    deleteConfirm: 'Bạn có chắc chắn muốn xoá khuyến mại này không?',
    uniqueQuantity: 'Số lượng tối thiểu của %s phải khác nhau!'
  },
  invalidField: {
    name: 'Vui lòng nhập trường tên hợp lệ!',
    timeFrom: 'Vui lòng nhập thời gian bắt đầu hợp lệ!',
    timeTo: 'Vui lòng nhập thời gian kết thúc hợp lệ!'
  },
  serviceSale: {
    branch: 'Chi nhánh',
    found: 'Không tìm thấy hàng hoá nào phù hợp',
    clickDownload: 'Bấm để tải',
    use: 'Sử dụng',
    empty: 'Còn trống',
    table: 'Bàn',
    emptyTable: 'Chưa có bàn nào được sử dụng',
    createBranchWarning: 'Bạn có thể thêm chi nhánh mới trên ứng dụng quản lý aSeller',
    addProduct: 'Thêm món',
    addProduct1: 'Thêm hàng',
    scanBarcode: 'Quét Mã',
    changeTable: 'Đổi bàn',
    orderNotCreate: 'Đơn hàng chưa được tạo hoặc chưa có sản phẩm',
    changeTableInput: 'Nhập số bàn cần đổi',
    error: 'Lỗi',
    finish: 'Xong',
    selected: 'Đã chọn',
    choiceProduct: 'Chọn món',
    choiceProduct1: 'Chọn mặt hàng',
    addNewProduct1: 'Thêm mặt hàng mới',
    addNewProduct: 'Thêm mới',
    selectTable: 'Chọn 1 bàn để tiếp tục',
    tableManagement: 'Quản lý bàn'
  },
  payment: {
    payment: 'Thanh toán',
    cash: 'Tiền mặt',
    transfer: 'Chuyển khoản',
    totalMoney: 'Tổng tiền',
    addOrder: 'Thêm vào giỏ hàng',
    order: 'Tạo đơn',
    number: 'Số lượng',
    total: 'Tổng',
    part: 'Phần',
    client: 'Khách hàng',
    customRetail: 'Khách lẻ',
    detailPayment: 'Chi tiết thanh toán',
    detailClient: 'Chi tiết khách hàng',
    nameUser: 'Tên khách hàng',
    newCustomer: 'Khách hàng mới',
    phone: 'SĐT',
    email: 'Email',
    address: 'Địa chỉ',
    free: 'Miễn phí',
    note: 'Ghi chú',
    updateOrder: 'Cập nhật đơn hàng',
    discount: 'Giảm giá',
    surcharge: 'Phụ phí',
    goodsMoney: 'Tiền hàng:',
    totalAmount: 'Tổng tiền phải thu:',
    notePayment: 'Sau khi xác nhận, sẽ ko thể thay đổi'
  },
  button: {
    yes: 'Có',
    no: 'Không',
    ok: 'Ok',
    cancel: 'Huỷ bỏ',
    save: 'Lưu',
    delete: 'Xóa',
    edit: 'Chỉnh sửa',
    edit2: 'Đổi tên',
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    success: 'Hoàn thành',
    finish: 'Xong',
    confirm: 'Xác nhận'
  },
  alert: {
    orderNotCreate: 'Đơn hàng chưa được tạo hoặc chưa có sản phẩm',
    enterFullData: 'Xin vui lòng nhập đủ dữ liệu có dấu sao',
    error: 'Lỗi',
    emptyBranch: 'Chưa có chi nhánh nào. Vui lòng liên hệ với chủ cửa hàng để tạo',
    messager: 'Thông báo',
    openingDay: 'Bạn không được chỉnh sửa khi ngày bắt đầu nhỏ hơn ngày hiện tại',
    delete: 'Bạn có chắc muốn xoá chỉnh sửa này',
    emptyInput: 'Tên đăng nhập hoặc mật khẩu không được để trống',
    success: 'Thành công',
    textEmpty: (value) => {
      return `Thông tin ${value} không được để trống`;
    },
    department: 'Bạn chưa chọn cơ sở',
    score: 'Điểm số không được lớn hơn số câu hỏi',
    logout: 'Bạn có chắc muốn thoát khỏi App không?',
    expiredLessThan7Day: 'Tài khoản của bạn đã hết hạn sử dụng, Bạn có thời gian sử dụng 7 ngày để gia hạn',
    expiredGreaterThan7Day: 'Tài khoản của bạn đã hết hạn sử dụng, Vui lòng liên hệ quản lý để gia hạn thêm',
    userNameHasSpace: 'Tên đăng nhập không được có dấu cách',
    userNameIsShort: 'Tên đăng nhập phải nhiều hơn 5 ký tự',
    passwordIsShort: 'Mật khẩu phải nhiều hơn 5 ký tự',
    emailInvalid: 'Email không hợp lệ',
    productCreateOrUpdateFaild: 'Lưu hàng hoá chưa thành công. Bạn hãy thử bỏ ảnh hoặc chọn ảnh khác nhé. Nếu vẫn lỗi, liên hệ đội hỗ trợ giúp bạn xử lý!'
  },
  composition: {
    create: 'Thêm thành phần',
    title: 'Thành phần',
    name: 'Tên thành phần',
    intro: 'Thành phần là một phần của sản phẩm. Mỗi sản phẩm có thể bao gồm nhiều thành phần khác nhau. Bạn có thể thêm thông tin thành phần trong mục sửa hoặc thêm sản phẩm',
    search: 'Tìm kiếm thành phần'
  },
  bussinessType: {
    title: 'Loại hình kinh doanh',
    detail: 'Chọn loại hình kinh doanh phù hợp với doanh nghiệp của bạn',
    type_0: 'Bán lẻ',
    type_1: 'Tạp hoá, Siêu thị',
    type_2: 'Cafe, trà sữa',
    type_3: 'Thời trang',
    type_4: 'Mỹ phẩm',
    type_5: 'Mẹ & Bé',
    type_6: 'Tiệm bánh',
    type_7: 'Nhà hàng',
    type_8: 'Karaoke, Bida',
    type_9: 'Nhà thuốc',
    type_10: 'Đồ chơi'
  },
  hourlyService: {
    name: 'Tên của mặt hàng tính giờ',
    nameHint: 'Tên của mặt hàng tính giờ sẽ xuất hiện như một mặt hàng trên hoá đơn',
    defaultName: 'Thời gian sử dụng',
    title: 'Tính tiền theo giờ',
    detail: 'Tính tiền theo giờ sử dụng dịch vụ. \nChỉ hỗ trợ trên giao diện bán lẻ, dịch vụ',
    tablePrice: 'Bảng giá tính giờ',
    errorData: 'Dữ liệu chưa hợp lệ. Vui lòng nhập đủ ít nhất 1 hàng!',
    stopTime: 'Dừng tính',
    stopTimeWarning: 'Bạn có muốn dừng tính giờ dịch vụ để thực hiện thanh toán không?'
  },
  extraTopping: {
    errorSeparateProductNonTopping: 'Không thể tách sản phẩm không có topping',
    list: 'Danh sách topping',
    isTopping: 'Là món thêm',
    detail:
      'Là loại hàng hoá đính kèm trong hàng hoá khác (VD topping chân trâu dành cho trà sữa...). \nBạn sẽ không thể thêm trực tiếp hàng hoá này vào đơn hàng..\nHàng hoá extra topping cũng sẽ không thể theo dõi tồn kho',
    choice: 'Chọn topping',
    name: 'Món thêm (Extra topping)',
    canNotAddToOrder: 'Hàng hoá topping không thể thêm trực tiếp vào đơn hàng.'
  },
  comboVoucher: {
    voucher: 'Mã voucher',
    activeVoucher: 'Kích hoạt mã voucher',
    activeVoucherDetail: 'Bạn đã có mã voucher? Kích hoạt mã của bạn ở đây.',
    emptyKey: 'Vui lòng nhập mã voucher!',
    choiceData: 'Hãy chọn dịch vụ bạn muốn kích hoạt bên dưới, sau đó bấm kích hoạt để hoàn thành.',
    invalidKey: 'Mã voucher không hợp lệ!',
    activeVoucherConfirm: 'Bạn có chắc chắn muốn kích hoạt mã này. Thao tác này sẽ không thể đảo ngược. Vui lòng kiểm tra kỹ trước khi bấm đồng ý.',
    activeSuccess: 'Kích hoạt mã thành công. Vui lòng tải lại trang để có hiệu lực.'
  },
  protection: {
    active: 'Kích hoạt bảo mật',
    detail: 'Tự động khoá ứng dụng bằng mã PIN sau khi không sử dụng',
    enterPass: 'Yêu cầu nhập mật mã',
    pin: 'Mật mã',
    pinRequire: 'Mật mã phải là 4 chữ số',
    wrongPass: 'Sai mật khẩu',
    forgotPin: 'Quên mã PIN',
    forgotPinDetail: 'Để đặt lại mã PIN. Bạn phải nhập lại mật khẩu của tài khoản. Bạn có chắc chắn muốn thực hiện điều này?'
  },
  extraFee: {
    name: 'Phụ phí mở rộng',
    detail: 'Phụ phí mở rộng cho đơn bán hàng. Số tiền sẽ được cộng vào trong đơn hàng. Nếu được bật thì nó sẽ hiển thị trong giao diện bán hàng',
    table: 'Bảng phụ phí mở rộng',
    fields: ['Tên', 'Giá trị mặc định', 'Đơn vị', 'Trạng thái', 'Hành động']
  },
  introData: [
    {
      title: 'Chào mừng bạn đến với aSeller POS!',
      detail: 'Giải pháp quản lý bán hàng thông minh giúp bạn kiểm soát cửa hàng mọi lúc, mọi nơi.'
    },
    {
      title: 'Quản lý đơn hàng, sản phẩm & khách hàng dễ dàng',
      detail: 'Theo dõi doanh thu, chi tiêu, công nợ, xuất nhập kho và in hóa đơn chỉ với vài thao tác.'
    },
    {
      title: 'Dữ liệu của bạn được lưu trữ trên nền tảng đám mây, đồng bộ dễ dàng trên nhiều thiết bị.',
      detail: '📶 Truy cập mọi lúc, không lo mất dữ liệu ngay cả khi thay đổi thiết bị!'
    },
    {
      title: 'Quản lý bán hàng chưa bao giờ dễ dàng đến thế!',
      detail: 'Tạo cửa hàng, thêm sản phẩm và bắt đầu bán ngay với aSeller POS.'
    }
  ],
  errorSupport: {
    title: 'Hệ thống xảy ra lỗi',
    detail: 'Hệ thống đang xảy ra lỗi. Xin vui lòng gửi thông báo này cho aSeller team để được hỗ trợ nhanh nhất nha!\nMã lỗi: %s',
    support: 'Yêu cầu hỗ trợ'
  },
  otherApps: [
    {
      title: 'Nhân viên aSeller bán hàng',
      detail: 'Ứng dụng này dành cho nhân viên. Bạn có thể tạo tài khoản nhân viên trong mục "Danh sách nhân viên - Thêm"'
    },
    {
      title: 'aSeller POS Offline',
      detail: 'Ứng dụng quản lý bán hàng miễn phí không cần internet. Không cần phí duy trì hàng tháng. Dữ liệu lưu trữ trên thiết bị. Không thể sử dụng trên nhiều thiết bị'
    },
    {
      title: 'aSeller FNB',
      detail: 'Ứng dụng quản lý chuyên biệt dành riêng cho nhà hàng, quán cafe, trà sữa. Giúp chủ shop tối ưu thời gian, tiết kiệm chi phí.'
    }
  ],
  appPermission: {
    title: 'Quyền truy cập ứng dụng',
    photo: {
      title: 'Quyền truy cập ảnh',
      detail: 'Ứng dụng yêu cầu quyền truy cập ảnh trên thiết bị để cập nhật ảnh đại diện, sản phẩm, khách hàng...'
    },
    camera: {
      title: 'Quyền truy cập máy ảnh',
      detail: 'Ứng dụng yêu cầu quyền truy cập máy ảnh trên thiết bị để chụp ảnh làm ảnh đại diện, sản phẩm, khách hàng...'
    },
    bluetooth: {
      title: 'Quyền truy cập Bluetooth',
      detail: 'Ứng dụng yêu cầu quyền truy cập Bluetooth để kết nối thiết bị máy in qua Bluetooth.'
    },
    notification: {
      title: 'Quyền truy cập thông báo',
      detail: 'Ứng dụng yêu cầu quyền truy cập thông báo để cập nhật những thông tin mới nhất về dịch vụ bạn sử dụng.'
    }
  },
  orderTemplate: {
    title: 'Hoá đơn mẫu',
    save: 'Lưu mẫu',
    list: 'HĐ Mẫu',
    saved: 'Đã lưu mẫu thành công!',
    name: 'Tên gợi nhớ',
    nameWarning: 'Vui lòng nhập tên gợi nhớ trên 3 ký tự',
    delete: 'Xoá đơn mẫu',
    deleteConfirm: 'Bạn có chắc chắn muốn xoá đơn hàng mẫu này ko?',
    hint: 'Đơn mẫu giúp bạn tạo đơn hàng giống nhau nhanh chóng. Nhấn giữ để xoá mẫu'
  },
  printSetting2: {
    manualEnterIP: 'Nhập IP thủ công',
    bill: 'Máy in hoá đơn',
    billDetail: 'Máy in nhiệt dùng để in hoá đơn bán hàng. Hỗ trợ giao thức ESC/POS, ESC, ZPL, EPL, TSPL, DPL, CPCL...',
    label: 'Máy in tem nhãn (dán)',
    labelDetail: 'Máy in nhiệt dùng để in tem dán sản phẩm. Hỗ trợ giao thức ZPL, EPL, TSPL, DPL, CPCL...',
    scan: 'Quét',
    rescan: 'Tìm kiếm lại',
    connect: 'Kết nối',
    disconnect: 'Huỷ kết nối',
    connected: 'Đã kết nối',
    scanning: 'Đang tìm kiếm',
    disconnectConfirm: 'Bạn có chắc chắn muốn huỷ kết nối với máy in này ko?',
    printerNotFound: 'Không tìm thấy máy in nào khác!',
    sunmiConnectError: 'Không thể kết nối đến máy in Sunmi. Vui lòng kiểm tra lại thiết bị!',
    usbConnectError: 'Không thể kết nối đến máy in USB. Vui lòng kiểm tra lại thiết bị!',
    sunmiDevice: 'Sunmi',
    labelPrinter: 'Máy in Tem nhãn',
    billPrinter: 'Máy in Hoá đơn',
    chooseConnectionAndDevice: 'Vui lòng chọn loại kết nối và thiết bị bên dưới',
    chooseWifiOrUsbForLabel: 'Vui lòng chọn Wifi hoặc USB bên dưới để kết nối máy in',
    printProtocol: 'Giao thức in:',
    blankLinesAfterBill: 'Khoảng cách trắng sau khi in hết hoá đơn',
    threshold: 'Độ nét (Threshold)',
    thresholdDetail: 'Điều chỉnh đậm nhạt của chữ',
    testPrint: 'In thử (Test)',
    alignContent: 'Canh lề nội dung sang trái/phải'
  },
  eInvoice: {
    intro: 'Thiết lập kết nối tới nhà cung cấp hóa đơn điện tử và cấu hình phát hành hoá đơn điện tử',
    title: 'Hoá đơn điện tử',
    setting: 'Cài đặt hoá đơn điện tử',
    provider: 'Nhà cung cấp HĐĐT',
    addConnect: 'Thêm kết nối',
    updateConnect: 'Sửa kết nối',
    reconnect: 'Kết nối lại',
    disconnect: 'Huỷ kết nối',
    disconnectWarning: 'Sau khi huỷ kết nối, bạn không thể tạo và truy cập HĐĐT từ nhà cung cấp này. Bạn có chắc chắn muốn huỷ kết nối đến nhà cung cấp này không?',
    account: 'Tài khoản',
    userName: 'Tên đăng nhập hệ thống HĐĐT',
    password: 'Mật khẩu',
    passwordDetail: 'Mật khẩu đăng nhập hệ thống HĐĐT',
    linkApi: 'Link máy chủ API',
    confirm: 'Bằng cách bấm lưu. Bạn đã đồng ý cho phép hệ thống quản lý bán hàng aSeller giúp tôi truyền/nhận hoá đơn từ aSeller đến đơn vị cung cấp HĐĐT mà tôi đã chọn.',
    taxCode: 'Mã số thuế',
    taxCodeDetail: 'Mã số thuế của doanh nghiệp hoặc hộ kinh doanh',
    settingForEInvoice: 'Cài đặt phát hành hoá đơn điện tử (HĐĐT)',
    allowPublish: 'Cho phép phát hành HĐĐT',
    autoPublish: 'Tự động phát hành HĐĐT',
    invoiceType: 'Kiểu hoá đơn',
    invoiceTypeData: ['Hoá đơn giá trị gia tăng', 'Hoá đơn máy tính tiền'],
    invoiceTemSeri: 'Mẫu và ký hiệu hoá đơn',
    info: 'Loại hoá đơn phát hành',
    export: 'Phát hành hoá đơn điện tử',
    infoDefaultHint: 'Loại hoá đơn phát hành mặc định khi tạo đơn hàng',
    deleteInfoConfirm: 'Bạn có chắc chắn muốn xoá mẫu hoá đơn này không?',
    addInfo: 'Thêm loại hoá đơn',
    updateInfo: 'Sửa hoá đơn',
    infoName: 'Tên hoá đơn',
    infoNameIsShort: 'Tên hoá đơn quá ngắn',
    templateInvalid: 'Mẫu và ký hiệu hoá đơn không hợp lệ',
    sellerInfo: 'Thông tin người bán trên HĐĐT',
    sellerInfoIntro: 'Nếu để trống hệ thống sẽ lấy thông tin cửa hàng trên aSeller',
    sellerName: 'Tên người bán',
    sellerAddress: 'Địa chỉ người bán',
    sellerEmail: 'Địa chỉ email người bán',
    sellerPhone: 'SĐT người bán',
    sellerBankName: 'Tên ngân hàng',
    sellerBankAccount: 'Số tài khoản ngân hàng',
    invalidField: 'Vui lòng nhập đầy đủ thông tin hợp lệ',
    unauthorized: 'Thông tin kết nối không hợp lệ. Vui lòng kiểm tra lại tài khoản và mật khẩu đăng nhập!',
    active: 'Bật phát hành hoá đơn điện tử',
    auto: 'Tự động phát hành hoá đơn điện tử',
    autoHint: 'Mỗi khi đơn bán hàng được lưu, hệ thống sẽ tự động truyền lên hệ thống của đơn vị cung cấp hoá đơn điện tử đã liên kết',
    showOnBill: 'Hiển thị thông tin tra cứu HĐĐT trên hoá đơn bán hàng',
    activeForOrderNotPay: 'Kích hoạt xuất HĐĐT cho tất cả đơn hàng',
    activeForOrderNotPayHint: 'Khi bỏ kích hoạt thì chỉ những đơn đã thanh toán mới xuất hoá đơn điện tử',
    invoiceNo: 'Số hoá đơn',
    transactionID: 'Mã giao dịch',
    codeOfTax: 'Mã CQT',
    reservationCode: 'Mã tra cứu',
    download: 'Tải file',
    checkLink: 'Tra cứu HĐĐT tại',
    create: 'Phát hành HĐĐT',
    createWarning: 'Bạn có chắc chắn muốn phát hành HĐĐT đơn hàng này không?',
    createAllWarning: 'Bạn có chắc chắn muốn phát hành HĐĐT cho %s đơn hàng đã chọn không?',
    tryAgain: 'Phát hành lại',
    creating: 'Đang phát hành HĐĐT',
    createError: 'Phát hành lỗi',
    reconciliation: 'Đối soát HĐĐT',
    createSuccess: 'Phát hành thành công',
    search: 'Nhập số hoá đơn, mã CQT, mã tra cứu',
    providerHint:
      'Bạn cần đăng ký dịch vụ từ nhà cung cấp hoá đơn điện tử và được cấp tài khoản mới có thể phát hành được hoá đơn điện tử. Nếu bạn chưa có tài khoản, vui lòng liên hệ hỗ trợ để được hướng dẫn đăng ký dịch vụ.',
    emptyEInfoWarning: 'Vui lòng thêm loại hoá đơn trước',
    emptyEConnectWarning: 'Vui lòng thêm kết nối với nhà cung cấp trước',
    notSupportEditWarning: 'Lưu ý: aSeller không hỗ trợ sửa hoá đơn điện tử sau khi đã phát hành. Để sửa đơn hàng, bạn hãy sửa trong hệ thống của nhà cung cấp hoá đơn điện tử.',
    autoSign: 'Tự động ký số và gửi cơ quan thuế (M-Invoice)',
    autoSignDetail:
      'Hoá đơn điện tự tạo ra sẽ được tự động ký số và gửi cơ quan thuế. Nếu tắt chức năng này. Các shop cần thao tác ký hoá đơn mới được gửi sang cơ quan thuế. Chỉ hỗ trợ nhà cung cấp M-Invoice',
    notSign: 'Chưa được ký',
    manualSign: 'Ký hoá đơn',
    manualSignWarning: 'Bạn có chắc chắn muốn ký hoá đơn này không? Sau khi ký, hoá đơn sẽ được gửi cho cơ quan thuế. aSeller không hỗ trợ sửa hoá đơn điện tử đã xuất'
  },
  servicesSetting: {
    slot: 'Sức chứa',
    prefix: 'Tên tiền tố',
    prefixDefault: 'Bàn',
    prefixEx: 'VD: Bàn, phòng...',
    title: 'Cài đặt giao diện dịch vụ',
    area: 'Khu vực',
    areaName: 'Tên khu vực',
    editArea: 'Sửa khu vực',
    addArea: 'Thêm khu vực',
    list: 'Danh sách dịch vụ',
    editName: 'Sửa tên dịch vụ',
    addAreaHint: 'Khu vực bán hàng có thể được thêm mới trong phần Cài đặt - Cài đặt cửa hàng',
    stopAreaActive: 'Ngừng kích hoạt khu vực',
    stopAreaActiveWarning: 'Bạn có chắc chắn muốn ngừng kích hoạt khu vực này không?',
    notFoundArea: 'Chưa có khu vực nào. Vui lòng tạo mới khu vực mới trong cài đặt cửa hàng.'
  },
  billSetting: {
    qrMoney: 'Số tiền mã QR',
    qrMoneyDetail: 'Tuỳ chọn số tiền hiển thị trên mã QR. Có thể là tổng số nợ của khách hàng hoặc số tiền của đơn hàng',
    qrMoneyType: ['Tổng nợ của khách', 'Số tiền đơn hàng']
  },
  stats: {
    contributionByStaff: 'Đóng góp theo nhân viên',
    summaryByStaff: 'Tổng quan theo nhân viên',
    saleByStaff: 'Doanh số theo nhân viên',
    revenue: 'Doanh thu',
    overview: 'Kết quả kinh doanh',
    productReport: 'Báo cáo hàng hoá',
    orderCount: 'Tổng đơn hàng',
    cashflow: 'Dòng tiền',
    cashflowIn30Days: 'Dòng tiền 30 ngày gần đây',
    cashflowInThisMonth: 'Dòng tiền tháng này',
    cashInflow: 'Dòng tiền vào',
    cashOutflow: 'Dòng tiền ra',
    remainingCash: 'Dòng tiền còn lại',
    netCash: 'Dòng tiền ròng',
    return: 'Hoàn lại',
    customerAndSuppliers: 'Khách hàng & Nhà cung cấp',
    salesChart: 'Biểu đồ doanh số',
    openBalance: 'Số dư ban đầu',
    openBalanceDetail:
      'Số dư ban đầu là sô tổng số dư (Dòng tiền vào - Dòng tiền ra) tính từ thời điểm ban đầu hoạt động đến thời điểm đầu kỳ. \nVD: Thời gian bạn chọn là tháng này, thì Số dư ban đầu nó là số dư từ trước ngày 01 đầu tháng trở về trước',
    orderFee: 'Chi phí đơn hàng',
    orderFeeChart: 'Biểu đồ chi phí đơn hàng',
    orderFeeDetails: 'Chi tiết chi phí theo ngày',
    totalVat: 'VAT',
    totalSurcharge: 'Phụ thu',
    totalSurchargeByCustomer: 'Phụ thu khách trả',
    totalSurchargeByShop: 'Phụ thu shop trả'
  },
  saleCounter: {
    weekChart: 'Biểu đồ tuần',
    invoice: 'HÓA ĐƠN',
    paymentSuccess: 'Thanh toán thành công!',
    error: 'Lỗi',
    selectVariant: 'Vui lòng chọn biến thể'
  },
  screenText: {
    staffLogin: {
      subtitle: 'Chào mừng nhân viên quay trở lại!',
      backToOwnerLogin: 'Quay lại đăng nhập chủ cửa hàng'
    },
    activeVoucher: {
      selectStaff: 'Chọn nhân viên',
      selectWarehouse: 'Chọn kho',
      requireStaff: 'Vui lòng chọn nhân viên để cập nhật gói!',
      requireWarehouse: 'Vui lòng chọn kho mở rộng để cập nhật gói!'
    },
    setting: {
      generalSubtitle: 'Quản lý ngôn ngữ và đơn vị tiền tệ chính.',
      currencyDescription: 'Ký hiệu tiền tệ hiển thị trong các báo cáo.',
      prefixSubtitle: 'Thiết lập các mã viết tắt cho đơn hàng và chứng từ.',
      homeSubtitle: 'Tùy chỉnh thông tin hiển thị tại trang chủ DashBoard.',
      aboutSubtitle: 'Chi tiết về phiên bản và hỗ trợ kỹ thuật.',
      aboutAppName: 'Quản lý bán hàng aSeller',
      aboutAppDesc: 'Giải pháp bán hàng chuyên nghiệp cho hộ kinh doanh.'
    },
    shopSetting: {
      noWebsite: 'Hệ thống chưa tạo Website cho cửa hàng của bạn.',
      vipExpired: 'Tài khoản Pro đã hết hạn',
      vipDuration: 'Thời gian duy trì gói VIP+',
      themeSampleTitle: 'Mẫu giao diện',
      themeSample1: 'Mẫu 1',
      themeSample2: 'Mẫu 2',
      advancedSubtitle: 'Quản lý các tính năng hiển thị nâng cao của Website.'
    },
    eInvoiceSetting: {
      tabConnect: 'Kết nối',
      tabSettings: 'Cấu hình',
      connectTitle: 'Kết nối Hóa đơn điện tử',
      settingsTitle: 'Cấu hình hệ thống',
      settingsSubtitle: 'Cấu hình tự động xuất hóa đơn và hiển thị thông tin.'
    },
    invoiceSetting: {
      bankTab: 'Tài khoản Bank',
      invoiceSubtitle: 'Cấu hình thông tin hiển thị và các tùy chọn cho hóa đơn bán hàng.',
      bankInfoTitle: 'Thông tin ngân hàng',
      bankInfoSubtitle: 'Cấu hình mã QR và thông tin tài khoản để nhận thanh toán chuyển khoản.',
      bankQrTitle: 'Mã QR ngân hàng',
      noBankQr: 'Chưa có mã QR',
      vietQrBankTitle: 'Tài khoản ngân hàng VietQR'
    },
    orderSetting: {
      orderSubtitle: 'Cấu hình quy trình xử lý đơn hàng và hiển thị thông tin bán hàng.',
      debtSubtitle: 'Quản lý công nợ khách hàng và ghi nhận nợ trên hóa đơn.',
      hourlySubtitle: 'Cài đặt dịch vụ tính phí theo thời gian (ví dụ: giờ chơi bida, karaoke...).',
      shipping: 'Vận chuyển',
      shippingSubtitle: 'Cấu hình thông tin vận chuyển và đơn vị vận chuyển.',
      extraTitle: 'Tiện ích & Phụ phí',
      extraSubtitle: 'Cài đặt các dịch vụ bổ sung và phụ phí tự động cho đơn hàng.'
    },
    pointSetting: {
      subtitle: 'Cấu hình hệ thống tích điểm và quy đổi điểm cho khách hàng.'
    },
    detail: {
      basicInfo: 'Thông tin cơ bản',
      attributesAndManagement: 'Thuộc tính & Quản lý',
      attributesAndTax: 'Thuộc tính & Thuế',
      groupInfo: 'Thông tin nhóm'
    },
    detailCustomer: {
      changePasswordDetail: 'Thay đổi mật khẩu đăng nhập cho tài khoản khách hàng',
      passwordMinLength: 'Mật khẩu phải lớn hơn 4 ký tự!'
    },
    customer: {
      taxCodeNotFound: 'Không tìm thấy thông tin mã số thuế'
    },
    receipt: {
      reason: 'Lý do',
      treasurer: 'Thủ quỹ',
      payer: 'Người nộp',
      creator: 'Người lập phiếu',
      signNameHint: '(Ký, họ tên)'
    },
    dashboard: {
      top1BestSeller: '#1 BÁN CHẠY NHẤT',
      noData: 'Chưa có dữ liệu',
      noDataHint: 'Bạn cần thêm sản phẩm để hiển thị thống kê này'
    },
    uploader: {
      chooseImageFile: 'Chọn file ảnh',
      chooseExcelFile: 'Chọn file Excel'
    }
  },
  shipping: {
    title: 'Vận chuyển',
    subtitle: 'Cấu hình các đơn vị vận chuyển và phương thức giao hàng',
    info: 'Thông tin vận chuyển',
    infoDetail: 'Tách biệt hoàn toàn với trạng thái đơn hàng hiện tại.',
    infoSub: 'Quản lý trạng thái vận chuyển, tracking và thông tin giao hàng.',
    noActive: 'Chưa có vận đơn hoạt động',
    noActiveDetail: 'Khởi tạo vận chuyển sau khi đơn hàng đã có địa chỉ giao và người nhận.',
    create: 'Tạo vận chuyển',
    bulkCreate: 'Tạo vận đơn hàng loạt',
    bulkCreateConfirm: 'Bạn có chắc chắn muốn tạo vận đơn cho %s đơn hàng với hãng %s không?',
    bulkCreateSuccess: 'Tạo vận đơn thành công cho %s đơn hàng.',
    bulkCreatePartial: 'Đã tạo vận đơn cho %s đơn hàng, còn %s đơn chưa thành công.',
    bulkCreateFailed: 'Không tạo được vận đơn hàng loạt.',
    createHint: 'Có thể tạo thủ công hoặc gọi API nhà cung cấp nếu hãng đã được cấu hình.',
    createMode: 'Chế độ tạo',
    createModeHintManual: 'Tạo vận đơn nội bộ và cho phép nhập mã vận đơn thủ công.',
    createModeHintProvider: 'Gọi API nhà cung cấp để tạo vận đơn và tự nhận mã vận đơn.',
    providerModeUnavailable: 'Hãng này chưa đủ cấu hình để tạo vận đơn qua API, hệ thống sẽ dùng chế độ thủ công.',
    providerCodeAutoGenerated: 'Mã vận đơn sẽ được nhà cung cấp trả về sau khi tạo thành công.',
    providerCreateFailed: 'Không tạo được vận đơn từ nhà cung cấp, chưa lưu vận đơn nội bộ.',
    providerEstimateFailed: 'Không lấy được phí vận chuyển từ nhà cung cấp.',
    estimateFee: 'Lấy phí từ nhà cung cấp',
    feeEstimated: 'Đã cập nhật phí vận chuyển từ nhà cung cấp.',
    reCreate: 'Tạo lại',
    update: 'Cập nhật',
    updateStatus: 'Cập nhật trạng thái',
    updateInfo: 'Sửa thông tin vận đơn',
    updateInfoTitle: 'Cập nhật thông tin vận đơn',
    updateInfoHint: 'Cho phép sửa mã vận đơn, link tracking, trạng thái từ nhà cung cấp và ghi chú mà không đổi trạng thái vận chuyển nội bộ.',
    updateStatusTitle: 'Cập nhật shipping status',
    updateStatusHint: 'Chỉ sử dụng các trạng thái shipping nội bộ, không ảnh hưởng dropdown Orders.status cũ.',
    cancel: 'Huỷ vận đơn',
    cancelConfirm: 'Xác nhận hủy vận đơn?',
    cancelWarning: 'Hành động này không thể hoàn tác.',
    irregularTransitionConfirm: 'Trạng thái bạn chọn không nằm trong luồng xử lý thông thường. Bạn có chắc chắn muốn cập nhật không?',
    status: 'Trạng thái vận chuyển',
    newStatus: 'Trạng thái mới',
    message: 'Tin nhắn',
    note: 'Ghi chú',
    tracking: 'Theo dõi',
    trackingCode: 'Mã vận đơn',
    trackingUrl: 'Link tracking',
    openTracking: 'Mở link tracking',
    provider: 'Đơn vị vận chuyển',
    providerStatusLabel: 'Trạng thái từ nhà cung cấp',
    providerRequired: 'Vui lòng chọn đơn vị vận chuyển.',
    providers: 'Hãng vận chuyển',
    providersDetail: 'Cấu hình GHN/GHTK/J&T/Viettel Post bằng form rõ ràng theo từng hãng. JSON thô chỉ nằm trong phần nâng cao cho dev/support.',
    addConfig: 'Thêm cấu hình',
    editConfig: 'Sửa cấu hình',
    saveConfigTitle: 'Lưu cấu hình hãng vận chuyển',
    saveConfig: 'Lưu cấu hình',
    displayName: 'Tên hiển thị',
    webhookSecret: 'Webhook secret',
    notConfigured: 'Chưa cấu hình',
    credentials: 'Thông tin xác thực',
    credentialsJson: 'Thông tin xác thực (JSON)',
    invalidCredentialsJson: 'Credentials JSON không hợp lệ',
    invalidProviderConfigJson: 'Credentials hoặc settings JSON không hợp lệ',
    providerSettings: 'Cấu hình provider',
    providerSettingsJson: 'Cấu hình provider (JSON)',
    providerConfigGuide: 'Trường gợi ý theo provider',
    providerAccountInfo: 'Thông tin tài khoản provider',
    providerConfigFromAccount: 'Thông tin này lấy từ tài khoản GHN/GHTK/J&T/Viettel Post hoặc thông tin kho lấy hàng của shop.',
    manualConfigDescription: 'Dùng khi shop đã có mã vận đơn từ ngoài và muốn nhập thủ công, không cần token hay cấu hình API.',
    providerSummary: 'Tóm tắt cấu hình',
    token: 'Token',
    newToken: 'Token mới',
    newTokenPlaceholder: 'Nhập token mới nếu muốn thay đổi',
    tokenConfigured: 'Đã cấu hình',
    tokenNotConfigured: 'Chưa cấu hình',
    configured: 'Đã cấu hình',
    environment: 'Môi trường',
    environmentList: {
      sandbox: 'Sandbox',
      production: 'Production'
    },
    autoMappedBaseUrl: 'URL API tự map',
    customBaseUrl: 'Custom baseUrl',
    serviceTypeId: 'Loại dịch vụ mặc định',
    paymentTypeId: 'Bên trả phí mặc định',
    paymentTypeList: {
      shop: 'Shop trả phí',
      customer: 'Khách trả phí'
    },
    shopId: 'Shop ID',
    partnerCode: 'Mã đối tác',
    customerCode: 'Mã khách hàng',
    jtApiKey: 'J&T API Key',
    viettelUsername: 'Viettel Username',
    viettelPassword: 'Viettel Password',
    viettelCredential: 'Token hoặc tài khoản Viettel',
    originCode: 'Mã điểm gửi (origin_code)',
    destinationCode: 'Mã điểm nhận (destination_code)',
    receiverArea: 'Mã khu vực nhận (receiver_area)',
    orderPrefix: 'Tiền tố mã đơn',
    createEndpoint: 'Endpoint tạo đơn',
    trackEndpoint: 'Endpoint tracking',
    payloadKey: 'Payload key tracking',
    pickupWarehouseInfo: 'Thông tin kho lấy hàng',
    pickupWarehouseHint: 'Điền đúng thông tin kho hoặc shop để GHTK tạo vận đơn tự động.',
    jtSenderHint: 'J&T cần đầy đủ thông tin người gửi để tạo vận đơn qua API.',
    viettelSenderHint: 'Viettel Post cần đầy đủ thông tin người gửi; có thể dùng token hoặc username/password để gọi API.',
    pickupName: 'Tên kho lấy hàng',
    pickupPhone: 'SĐT kho lấy hàng',
    pickupAddress: 'Địa chỉ kho lấy hàng',
    pickupProvince: 'Tỉnh/Thành kho',
    pickupDistrict: 'Quận/Huyện kho',
    pickupWard: 'Phường/Xã kho',
    ghnProvince: 'Tỉnh/Thành (GHN)',
    ghnDistrict: 'Quận/Huyện (GHN)',
    ghnWard: 'Phường/Xã (GHN)',
    ghnAddressHint: 'Vui lòng chọn địa chỉ chuẩn GHN để tạo đơn.',
    ghnMasterDataError: 'Lỗi lấy dữ liệu địa chỉ GHN. Vui lòng thử lại.',
    advancedSettings: 'Nâng cao',
    advancedSettingsHint: 'Chỉ dùng khi cần override baseUrl hoặc nhập thêm JSON raw cho dev/support.',
    credentialsJsonAdvanced: 'Credentials JSON (nâng cao)',
    providerSettingsJsonAdvanced: 'Settings JSON (nâng cao)',
    requiredFieldMissing: 'Vui lòng cấu hình %s trước khi lưu.',
    hasData: 'Đã có dữ liệu',
    empty: 'Để trống',
    none: 'Không có',
    activeThisProvider: 'Kích hoạt hãng này',
    code: 'Mã vận đơn',
    receiver: 'Người nhận',
    phone: 'Số điện thoại',
    address: 'Địa chỉ nhận',
    fee: 'Phí vận chuyển',
    cod: 'Tiền COD',
    lastWebhook: 'Lần webhook cuối',
    notUpdate: 'Chưa cập nhật',
    timeline: 'Lịch sử vận chuyển',
    history: 'Lịch sử vận chuyển',
    timelineDetail: 'Lịch sử cập nhật từ webhook hoặc thao tác thủ công.',
    noLogs: 'Chưa có lịch sử vận chuyển.',
    waitSync: 'Đang chờ đồng bộ',
    updateHint: 'Cập nhật trạng thái vận chuyển.',
    currentStatusHint: 'Trạng thái hiện tại của vận đơn.',
    updatedBy: 'Thực hiện bởi',
    statusList: {
      none: 'Chưa tạo',
      draft: 'Mới tạo',
      awaiting_pickup: 'Chờ lấy hàng',
      pickup_in_progress: 'Đang lấy hàng',
      picked_up: 'Đã lấy hàng',
      sorting: 'Đang phân loại',
      in_transit: 'Đang giao hàng',
      out_for_delivery: 'Đang đi giao',
      delivered: 'Giao thành công',
      delivery_failed: 'Giao thất bại',
      canceled: 'Đã hủy',
      return_requested: 'Yêu cầu hoàn hàng',
      return_in_transit: 'Đang hoàn hàng',
      returned: 'Đã hoàn hàng',
      exception: 'Sự cố'
    },
    providerList: {
      manual: 'Thủ công',
      manualDetail: 'Nhập tay và cập nhật thủ công',
      ghn: 'Giao Hàng Nhanh',
      ghnDetail: 'Tích hợp API GHN',
      ghtk: 'Giao Hàng Tiết Kiệm',
      ghtkDetail: 'Tích hợp API GHTK',
      jt: 'J&T Express',
      jtDetail: 'Tích hợp API J&T',
      viettel_post: 'Viettel Post',
      viettel_postDetail: 'Tích hợp API Viettel Post'
    },
    createModeList: {
      manual: 'Tạo thủ công',
      provider: 'Tạo qua nhà cung cấp'
    },
    configFieldLabels: {
      token: 'Token',
      environment: 'Môi trường',
      baseUrl: 'URL API',
      serviceTypeId: 'Loại dịch vụ mặc định',
      paymentTypeId: 'Bên trả phí mặc định',
      webhookSecret: 'Webhook secret',
      shopId: 'Shop ID',
      key: 'J&T API Key',
      customerCode: 'Mã khách hàng',
      username: 'Viettel Username',
      password: 'Viettel Password',
      originCode: 'Mã điểm gửi',
      destinationCode: 'Mã điểm nhận',
      receiverArea: 'Mã khu vực nhận',
      pickupName: 'Tên kho lấy hàng',
      pickupPhone: 'SĐT kho lấy hàng',
      pickupAddress: 'Địa chỉ kho lấy hàng',
      pickupProvince: 'Tỉnh/Thành kho',
      pickupDistrict: 'Quận/Huyện kho',
      pickupWard: 'Phường/Xã kho'
    }
  }
};
